import { useState, useEffect } from "react";

// ─── PALETA E ESTILOS GLOBAIS ───────────────────────────────────────────────
const C = {
  terracota: "#B5651D",
  terracotaLight: "#D4845A",
  terracotaDark: "#8B4513",
  verde: "#6B8F5E",
  verdLight: "#8FBF7F",
  creme: "#F5F0E8",
  cremeDark: "#EDE5D8",
  branco: "#FFFFFF",
  escuro: "#1C1A16",
  texto: "#3D2B1F",
  textoMuted: "#8B7355",
  fundo: "#FDFAF6",
  notif: "#E8935A",
};

const s = {
  app: {
    fontFamily: "'Georgia', serif",
    background: C.fundo,
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
  },
  phone: {
    width: "390px",
    minHeight: "844px",
    background: C.fundo,
    position: "relative",
    overflow: "hidden",
    boxShadow: "0 0 60px rgba(0,0,0,0.15)",
  },
  screen: {
    width: "100%",
    minHeight: "844px",
    display: "flex",
    flexDirection: "column",
    background: C.fundo,
    paddingBottom: "80px",
  },
  topBar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "16px 20px 8px",
    position: "relative",
  },
  backBtn: {
    position: "absolute",
    left: "20px",
    background: "none",
    border: "none",
    fontSize: "22px",
    color: C.texto,
    cursor: "pointer",
    padding: "4px",
  },
  logo: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  bottomNav: {
    position: "fixed",
    bottom: "0",
    width: "390px",
    height: "70px",
    background: C.terracota,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-around",
    borderRadius: "20px 20px 0 0",
    padding: "0 4px",
  },
  navBtn: (active) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "2px",
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: "8px 16px",
    borderRadius: "50%",
    color: active ? C.escuro : "rgba(255,255,255,0.7)",
  }),
  navBtnActive: {
    background: C.creme,
    borderRadius: "50%",
    width: "46px",
    height: "46px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: C.terracota,
  },
  btn: {
    width: "100%",
    padding: "16px",
    background: C.terracota,
    color: C.branco,
    border: "none",
    borderRadius: "30px",
    fontSize: "16px",
    fontFamily: "'Georgia', serif",
    cursor: "pointer",
    fontWeight: "600",
    letterSpacing: "0.5px",
  },
  btnOutline: {
    width: "100%",
    padding: "16px",
    background: C.cremeDark,
    color: C.texto,
    border: "none",
    borderRadius: "30px",
    fontSize: "16px",
    fontFamily: "'Georgia', serif",
    cursor: "pointer",
  },
  input: {
    width: "100%",
    padding: "14px 0",
    background: "transparent",
    border: "none",
    borderBottom: `1.5px solid ${C.texto}`,
    fontSize: "15px",
    fontFamily: "'Georgia', serif",
    color: C.texto,
    outline: "none",
    boxSizing: "border-box",
  },
  label: {
    fontSize: "12px",
    color: C.textoMuted,
    letterSpacing: "0.5px",
    marginBottom: "2px",
    display: "block",
  },
  title: {
    fontSize: "32px",
    fontWeight: "700",
    color: C.terracota,
    lineHeight: "1.2",
    marginBottom: "8px",
  },
  sectionTitle: {
    fontSize: "18px",
    fontWeight: "700",
    color: C.texto,
    borderBottom: `2px solid ${C.terracota}`,
    paddingBottom: "6px",
    display: "inline-block",
    marginBottom: "20px",
  },
  card: {
    background: C.branco,
    borderRadius: "16px",
    padding: "20px",
    marginBottom: "12px",
    boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
  },
  cardTerracota: {
    background: C.terracota,
    borderRadius: "16px",
    padding: "20px",
    marginBottom: "12px",
    color: C.branco,
  },
};

// ─── LOGO SVG MEZA ───────────────────────────────────────────────────────────


const MezaLogo = ({ size = 80 }) => {
  const cx = 80, cy = 80;
  const gx = cx - 12;
  return (
    <svg width={size} height={size} viewBox="0 0 160 160">
      {/* Prato — círculo externo mais grosso */}
      <circle cx={cx} cy={cy} r={50} fill="none" stroke="#6B8F5E" strokeWidth="4"/>
      {/* Prato — círculo interno mais fino */}
      <circle cx={cx} cy={cy} r={32} fill="none" stroke="#6B8F5E" strokeWidth="1.8"/>
      {/* Alvo — linhas a verde */}
      <line x1={cx} y1={cy-50} x2={cx} y2={cy+50} stroke="#6B8F5E" strokeWidth="1.5" strokeLinecap="round"/>
      <line x1={cx-50} y1={cy} x2={cx+50} y2={cy} stroke="#6B8F5E" strokeWidth="1.5" strokeLinecap="round"/>
      {/* Ponto central — maior */}
      <circle cx={cx} cy={cy} r={5.5} fill="#B5651D"/>
      {/* GARFO — dentes mais compridos */}
      <line x1={gx-2.5} y1={cy-22} x2={gx-2.5} y2={cy-11} stroke="#B5651D" strokeWidth="1.3" strokeLinecap="round"/>
      <line x1={gx}     y1={cy-22} x2={gx}     y2={cy-9} stroke="#B5651D" strokeWidth="1.5" strokeLinecap="round"/>
      <line x1={gx+2.5} y1={cy-22} x2={gx+2.5} y2={cy-11} stroke="#B5651D" strokeWidth="1.3" strokeLinecap="round"/>
      {/* Haste */}
      <line x1={gx} y1={cy-9} x2={gx} y2={cy+20} stroke="#B5651D" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  );
};

const MezaWordmark = ({ size = "normal", onClick }) => (
  <div style={{ textAlign: "center", lineHeight: 1, cursor: onClick ? "pointer" : "default" }} onClick={onClick}>
    <span style={{ fontSize: size === "large" ? "42px" : size === "small" ? "22px" : "32px", fontWeight: "700", fontFamily: "Georgia, serif", letterSpacing: "3px" }}>
      <span style={{ color: C.terracota }}>Me</span>
      <span style={{ color: C.verde }}>Z</span>
      <span style={{ color: C.terracota }}>a</span>
    </span>
    <div style={{ fontSize: size === "large" ? "11px" : "9px", color: C.terracota, letterSpacing: "2.5px", opacity: 0.65, marginTop: "2px" }}>by Sankofa Lab</div>
  </div>
);

// ─── BOTTOM NAV ──────────────────────────────────────────────────────────────
const BottomNav = ({ active, onNavigate }) => {
  const items = [
    { id: "menu", icon: "☰", label: "" },
    { id: "sugestoes", icon: "♡", label: "" },
    { id: "notificacoes", icon: "🔔", label: "" },
    { id: "perfil", icon: "👤", label: "" },
  ];
  return (
    <div style={s.bottomNav}>
      {items.map((item) => (
        <button key={item.id} onClick={() => onNavigate(item.id)} style={{ background: "none", border: "none", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>
          {active === item.id ? (
            <div style={{ background: C.creme, borderRadius: "50%", width: "46px", height: "46px", display: "flex", alignItems: "center", justifyContent: "center", color: C.terracota, fontSize: "18px" }}>
              {item.icon}
            </div>
          ) : (
            <span style={{ color: "rgba(255,255,255,0.75)", fontSize: "22px" }}>{item.icon}</span>
          )}
        </button>
      ))}
    </div>
  );
};

// ─── DEMO PLAYER ─────────────────────────────────────────────────────────────
const DemoPlayer = ({ tipo, onClose, onNavigate }) => {
  const fluxoEmpresa = [
    { screen: "splash",        dur: 2000, label: "Ecrã inicial" },
    { screen: "tipoConta",     dur: 2500, label: "Escolha de perfil" },
    { screen: "onboardingEmpresa", dur: 3500, label: "Onboarding — Boas-vindas" },
    { screen: "menu",          dur: 3000, label: "Dashboard Empresa" },
    { screen: "adicionarCompra1", dur: 2500, label: "Adicionar compra" },
    { screen: "adicionarCompra2", dur: 3000, label: "Formulário de compra" },
    { screen: "sugestoes",     dur: 3500, label: "Produtores locais no mapa" },
    { screen: "pegadaCarbono1",dur: 2500, label: "Pegada de carbono" },
    { screen: "pegadaCarbono2",dur: 2500, label: "Categorias de impacto" },
    { screen: "pegadaTotal",   dur: 3000, label: "Total de emissões" },
    { screen: "melhorias",     dur: 3000, label: "Sugestões de melhoria" },
    { screen: "relatorios",    dur: 3000, label: "Relatórios" },
    { screen: "receitas",      dur: 3000, label: "Receitas anti-desperdício" },
    { screen: "curiosidades",  dur: 3000, label: "Saber mais" },
    { screen: "perfil",        dur: 3500, label: "Perfil e conquistas" },
  ];

  const fluxoIndividual = [
    { screen: "splash",           dur: 2000, label: "Ecrã inicial" },
    { screen: "tipoConta",        dur: 2500, label: "Escolha de perfil" },
    { screen: "onboardingIndividual", dur: 3500, label: "Onboarding — Boas-vindas" },
    { screen: "menuIndividual",   dur: 3500, label: "Dashboard Individual" },
    { screen: "sugestoes",        dur: 3500, label: "Produtores perto de mim" },
    { screen: "curiosidades",     dur: 3000, label: "Curiosidades do dia" },
    { screen: "receitas",         dur: 3000, label: "Receitas anti-desperdício" },
    { screen: "pegadaIndividual", dur: 3500, label: "A minha pegada pessoal" },
    { screen: "perfil",           dur: 3500, label: "Perfil e conquistas" },
  ];

  const fluxo = tipo === "empresa" ? fluxoEmpresa : fluxoIndividual;
  const [passo, setPasso] = useState(0);
  const [progresso, setProgresso] = useState(0);
  const [pausado, setPausado] = useState(false);
  const [terminado, setTerminado] = useState(false);

  const passoAtual = fluxo[passo];
  const totalDur = fluxo.reduce((acc, f) => acc + f.dur, 0);

  // Navegar para o ecrã do passo atual
  useState(() => { onNavigate(passoAtual.screen); }, []);

  // Timer por passo
  useEffect(() => {
    if (pausado || terminado) return;
    onNavigate(fluxo[passo].screen);
    let elapsed = 0;
    const interval = setInterval(() => {
      if (pausado) return;
      elapsed += 50;
      setProgresso(elapsed / fluxo[passo].dur * 100);
      if (elapsed >= fluxo[passo].dur) {
        clearInterval(interval);
        if (passo + 1 < fluxo.length) {
          setPasso(p => p + 1);
          setProgresso(0);
        } else {
          setTerminado(true);
        }
      }
    }, 50);
    return () => clearInterval(interval);
  }, [passo, pausado, terminado]);

  const progressoGlobal = fluxo.slice(0, passo).reduce((acc, f) => acc + f.dur, 0) / totalDur * 100;

  return (
    <div style={{ position: "fixed", inset: 0, zIndex: 500, display: "flex", flexDirection: "column" }}>
      {/* Overlay superior */}
      <div style={{ background: "rgba(0,0,0,0.92)", padding: "16px 20px 12px", display: "flex", alignItems: "center", gap: "12px" }}>
        <div style={{ flex: 1 }}>
          <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "6px" }}>
            <div style={{ width: "8px", height: "8px", borderRadius: "50%", background: terminado ? C.verde : pausado ? "#F59E0B" : "#EF4444", boxShadow: terminado || pausado ? "none" : "0 0 6px #EF4444" }} />
            <span style={{ color: C.branco, fontSize: "12px", fontWeight: "700", letterSpacing: "1px" }}>
              {terminado ? "DEMO CONCLUÍDA" : pausado ? "PAUSADO" : "EM REPRODUÇÃO"}
            </span>
            <span style={{ color: "rgba(255,255,255,0.5)", fontSize: "12px", marginLeft: "auto" }}>
              {tipo === "empresa" ? "🏢 Empresa" : "🌱 Individual"}
            </span>
          </div>
          {/* Barra de progresso global */}
          <div style={{ background: "rgba(255,255,255,0.15)", borderRadius: "4px", height: "4px", marginBottom: "6px" }}>
            <div style={{ background: tipo === "empresa" ? C.terracota : C.verde, borderRadius: "4px", height: "4px", width: `${progressoGlobal + (progresso / 100 * fluxo[passo].dur / totalDur * 100)}%`, transition: "width 0.05s linear" }} />
          </div>
          {/* Label do ecrã atual */}
          {!terminado && (
            <div style={{ color: "rgba(255,255,255,0.75)", fontSize: "12px" }}>
              {passo + 1}/{fluxo.length} — {passoAtual.label}
            </div>
          )}
        </div>
        <button onClick={onClose} style={{ background: "rgba(255,255,255,0.15)", border: "none", borderRadius: "50%", width: "32px", height: "32px", color: C.branco, cursor: "pointer", fontSize: "16px", flexShrink: 0 }}>✕</button>
      </div>

      {/* Miniaturas de ecrãs */}
      <div style={{ background: "rgba(0,0,0,0.85)", padding: "8px 12px", display: "flex", gap: "6px", overflowX: "auto" }}>
        {fluxo.map((f, i) => (
          <button key={i} onClick={() => { setPasso(i); setProgresso(0); setTerminado(false); }}
            style={{ flexShrink: 0, padding: "5px 10px", borderRadius: "8px", border: `1.5px solid ${i === passo ? (tipo === "empresa" ? C.terracota : C.verde) : "transparent"}`, background: i < passo ? "rgba(255,255,255,0.1)" : i === passo ? "rgba(255,255,255,0.15)" : "transparent", color: i === passo ? C.branco : "rgba(255,255,255,0.4)", fontSize: "11px", cursor: "pointer", whiteSpace: "nowrap" }}>
            {i < passo ? "✓ " : i === passo ? "▶ " : ""}{f.label}
          </button>
        ))}
      </div>

      {/* Barra de progresso do passo atual */}
      {!terminado && (
        <div style={{ background: "rgba(0,0,0,0.7)", height: "3px" }}>
          <div style={{ background: tipo === "empresa" ? C.terracota : C.verde, height: "3px", width: `${progresso}%`, transition: "width 0.05s linear" }} />
        </div>
      )}

      {/* Ecrã terminado */}
      {terminado && (
        <div style={{ position: "absolute", bottom: "100px", left: "50%", transform: "translateX(-50%)", background: "rgba(0,0,0,0.9)", borderRadius: "20px", padding: "24px 28px", textAlign: "center", width: "300px" }}>
          <div style={{ fontSize: "40px", marginBottom: "10px" }}>🎬</div>
          <div style={{ color: C.branco, fontWeight: "700", fontSize: "16px", marginBottom: "6px", fontFamily: "Georgia, serif" }}>Demo concluída!</div>
          <p style={{ color: "rgba(255,255,255,0.7)", fontSize: "13px", marginBottom: "16px" }}>Queres explorar outra versão ou entrar na app?</p>
          <div style={{ display: "flex", gap: "8px" }}>
            <button onClick={() => { setPasso(0); setProgresso(0); setTerminado(false); }}
              style={{ flex: 1, padding: "10px", background: "rgba(255,255,255,0.15)", border: "none", borderRadius: "10px", color: C.branco, fontSize: "12px", cursor: "pointer", fontFamily: "Georgia, serif" }}>
              ↺ Repetir
            </button>
            <button onClick={onClose}
              style={{ flex: 1, padding: "10px", background: tipo === "empresa" ? C.terracota : C.verde, border: "none", borderRadius: "10px", color: C.branco, fontSize: "12px", cursor: "pointer", fontFamily: "Georgia, serif" }}>
              Entrar →
            </button>
          </div>
        </div>
      )}

      {/* Controlos */}
      <div style={{ position: "absolute", bottom: "20px", left: "50%", transform: "translateX(-50%)", display: "flex", gap: "12px", zIndex: 10 }}>
        <button onClick={() => { if (passo > 0) { setPasso(p => p - 1); setProgresso(0); setTerminado(false); } }}
          style={{ width: "44px", height: "44px", borderRadius: "50%", background: "rgba(255,255,255,0.15)", border: "none", color: C.branco, fontSize: "20px", cursor: "pointer" }}>
          ⏮
        </button>
        <button onClick={() => setPausado(p => !p)}
          style={{ width: "56px", height: "56px", borderRadius: "50%", background: tipo === "empresa" ? C.terracota : C.verde, border: "none", color: C.branco, fontSize: "22px", cursor: "pointer", boxShadow: "0 4px 16px rgba(0,0,0,0.4)" }}>
          {pausado ? "▶" : "⏸"}
        </button>
        <button onClick={() => { if (passo + 1 < fluxo.length) { setPasso(p => p + 1); setProgresso(0); } else setTerminado(true); }}
          style={{ width: "44px", height: "44px", borderRadius: "50%", background: "rgba(255,255,255,0.15)", border: "none", color: C.branco, fontSize: "20px", cursor: "pointer" }}>
          ⏭
        </button>
      </div>
    </div>
  );
};

// ─── ECRÃ 1: SPLASH ──────────────────────────────────────────────────────────
const SplashScreen = ({ onNavigate, onStartDemo }) => (
  <div style={{ ...s.screen, justifyContent: "center", alignItems: "center", gap: "0", paddingBottom: 0 }}>
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "24px", padding: "40px 40px 60px" }}>
      <MezaLogo size={140} />
      <div style={{ marginTop: "-8px" }}>
        <MezaWordmark size="large" />
      </div>
      <p style={{ fontStyle: "italic", color: C.textoMuted, textAlign: "center", fontSize: "16px", lineHeight: 1.5, marginTop: "8px" }}>
        O teu impacto começa com<br />o que escolhes pôr na mesa.
      </p>
      <div style={{ width: "100%", display: "flex", flexDirection: "column", gap: "12px", marginTop: "32px" }}>
        <button style={s.btn} onClick={() => onNavigate("login")}>Iniciar sessão</button>
        <button style={s.btnOutline} onClick={() => onNavigate("tipoConta")}>Criar conta</button>
      </div>

      {/* Demos manuais */}
      <div style={{ width: "100%", borderTop: `1px solid ${C.cremeDark}`, paddingTop: "16px" }}>
        <div style={{ fontSize: "11px", color: C.textoMuted, textAlign: "center", letterSpacing: "1px", marginBottom: "10px" }}>EXPLORAR DEMO</div>
        <div style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
          <button onClick={() => onNavigate("menu")}
            style={{ flex: 1, padding: "12px", background: C.cremeDark, border: `1.5px solid ${C.terracota}`, borderRadius: "14px", cursor: "pointer", fontFamily: "Georgia, serif", fontSize: "13px", color: C.terracota, fontWeight: "700" }}>
            🏢 Empresa
          </button>
          <button onClick={() => onNavigate("menuIndividual")}
            style={{ flex: 1, padding: "12px", background: C.cremeDark, border: `1.5px solid ${C.verde}`, borderRadius: "14px", cursor: "pointer", fontFamily: "Georgia, serif", fontSize: "13px", color: C.verde, fontWeight: "700" }}>
            🌱 Individual
          </button>
        </div>

        {/* Demos em vídeo */}
        <div style={{ fontSize: "11px", color: C.textoMuted, textAlign: "center", letterSpacing: "1px", marginBottom: "10px", marginTop: "6px" }}>DEMO EM VÍDEO</div>
        <div style={{ display: "flex", gap: "10px" }}>
          <button onClick={() => onStartDemo("empresa")}
            style={{ flex: 1, padding: "12px", background: C.terracota, border: "none", borderRadius: "14px", cursor: "pointer", fontFamily: "Georgia, serif", fontSize: "13px", color: C.branco, fontWeight: "700", display: "flex", alignItems: "center", justifyContent: "center", gap: "6px" }}>
            ▶ 🏢 Empresa
          </button>
          <button onClick={() => onStartDemo("individual")}
            style={{ flex: 1, padding: "12px", background: C.verde, border: "none", borderRadius: "14px", cursor: "pointer", fontFamily: "Georgia, serif", fontSize: "13px", color: C.branco, fontWeight: "700", display: "flex", alignItems: "center", justifyContent: "center", gap: "6px" }}>
            ▶ 🌱 Individual
          </button>
        </div>
      </div>
    </div>
  </div>
);

// ─── ECRÃ 2: TIPO DE CONTA ───────────────────────────────────────────────────
const TipoContaScreen = ({ onNavigate }) => (
  <div style={s.screen}>
    <div style={s.topBar}>
      <button style={s.backBtn} onClick={() => onNavigate("splash")}>‹</button>
      <MezaWordmark />
    </div>
    <div style={{ padding: "40px 28px", display: "flex", flexDirection: "column", gap: "20px" }}>
      <div>
        <h2 style={{ ...s.title, fontSize: "28px" }}>Bem-vindo/a!</h2>
        <p style={{ color: C.textoMuted, fontSize: "15px" }}>Como queres utilizar a MeZa?</p>
      </div>
      <button onClick={() => onNavigate("criarContaEmpresa")} style={{ background: C.cremeDark, border: `2px solid ${C.terracota}`, borderRadius: "20px", padding: "28px 24px", textAlign: "left", cursor: "pointer", transition: "all 0.2s" }}>
        <div style={{ fontSize: "36px", marginBottom: "12px" }}>🏢</div>
        <div style={{ fontSize: "18px", fontWeight: "700", color: C.terracota, fontFamily: "Georgia, serif", marginBottom: "6px" }}>Sou empresa</div>
        <div style={{ fontSize: "14px", color: C.textoMuted, lineHeight: 1.5 }}>Restaurante, negócio alimentar ou produtor. Monitoriza compras, pegada de carbono e gera relatórios de impacto.</div>
      </button>
      <button onClick={() => onNavigate("criarContaIndividual")} style={{ background: C.cremeDark, border: `2px solid ${C.verde}`, borderRadius: "20px", padding: "28px 24px", textAlign: "left", cursor: "pointer", transition: "all 0.2s" }}>
        <div style={{ fontSize: "36px", marginBottom: "12px" }}>🌱</div>
        <div style={{ fontSize: "18px", fontWeight: "700", color: C.verde, fontFamily: "Georgia, serif", marginBottom: "6px" }}>Sou individual</div>
        <div style={{ fontSize: "14px", color: C.textoMuted, lineHeight: 1.5 }}>Consumidor consciente. Toma decisões mais informadas, reduz o teu impacto e aprende sobre sustentabilidade.</div>
      </button>
    </div>
  </div>
);

// ─── ECRÃ 3: LOGIN ───────────────────────────────────────────────────────────
const LoginScreen = ({ onNavigate }) => {
  const [tab, setTab] = useState("login");
  return (
    <div style={s.screen}>
      <div style={s.topBar}>
        <MezaWordmark />
      </div>
      <div style={{ padding: "0 28px 28px" }}>
        {/* Tabs */}
        <div style={{ display: "flex", borderBottom: `1px solid ${C.cremeDark}`, marginBottom: "32px" }}>
          {["login", "criar"].map((t) => (
            <button key={t} onClick={() => t === "criar" ? onNavigate("tipoConta") : setTab(t)}
              style={{ flex: 1, padding: "12px", background: "none", border: "none", borderBottom: tab === t ? `2px solid ${C.terracota}` : "2px solid transparent", color: tab === t ? C.terracota : C.textoMuted, fontFamily: "Georgia, serif", fontSize: "15px", cursor: "pointer", marginBottom: "-1px" }}>
              {t === "login" ? "Iniciar sessão" : "Criar conta"}
            </button>
          ))}
        </div>
        <h2 style={s.title}>Bem-vindo/a de volta!</h2>
        <div style={{ display: "flex", flexDirection: "column", gap: "20px", marginTop: "32px" }}>
          <div>
            <label style={s.label}>Email</label>
            <input style={s.input} placeholder="o_teu@email.com" />
          </div>
          <div>
            <label style={s.label}>Palavra-passe</label>
            <div style={{ position: "relative" }}>
              <input style={s.input} type="password" placeholder="••••••••" />
              <span style={{ position: "absolute", right: 0, top: "14px", cursor: "pointer" }}>👁</span>
            </div>
          </div>
          <div style={{ textAlign: "right" }}>
            <button onClick={() => onNavigate("esqueceuPassword")} style={{ background: "none", border: "none", color: C.textoMuted, fontSize: "13px", cursor: "pointer" }}>
              Esqueci-me da palavra-passe
            </button>
          </div>
        </div>
        <div style={{ margin: "28px 0", textAlign: "center", color: C.textoMuted, fontSize: "13px" }}>ou</div>
        <div style={{ display: "flex", justifyContent: "center", gap: "16px", marginBottom: "28px" }}>
          {[{ icon: "🍎", label: "Apple" }, { icon: "G", label: "Google", style: { fontWeight: "700", color: "#EA4335" } }, { icon: "f", label: "Facebook", style: { fontWeight: "700", color: "#1877F2" } }].map((p) => (
            <button key={p.label} style={{ width: "56px", height: "56px", borderRadius: "50%", background: C.cremeDark, border: "none", cursor: "pointer", fontSize: "20px", ...p.style }}>
              {p.icon}
            </button>
          ))}
        </div>
        <button style={s.btn} onClick={() => onNavigate("menu")}>Iniciar sessão</button>
      </div>
    </div>
  );
};

// ─── ECRÃ 4: CRIAR CONTA EMPRESA ─────────────────────────────────────────────
const CriarContaEmpresaScreen = ({ onNavigate }) => (
  <div style={s.screen}>
    <div style={s.topBar}>
      <button style={s.backBtn} onClick={() => onNavigate("tipoConta")}>‹</button>
      <MezaWordmark />
    </div>
    <div style={{ padding: "0 28px 28px" }}>
      <div style={{ display: "flex", borderBottom: `1px solid ${C.cremeDark}`, marginBottom: "24px" }}>
        <button style={{ flex: 1, padding: "12px", background: "none", border: "none", borderBottom: `2px solid ${C.terracota}`, color: C.terracota, fontFamily: "Georgia, serif", fontSize: "15px" }}>Empresa</button>
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: "18px" }}>
        {[
          { label: "Nome", placeholder: "O teu nome" },
          { label: "Email", placeholder: "o_teu@email.com" },
          { label: "Palavra-passe", placeholder: "••••••••", type: "password" },
          { label: "Repetir palavra-passe", placeholder: "••••••••", type: "password" },
          { label: "Nome da empresa", placeholder: "Restaurante Exemplo" },
          { label: "NIF", placeholder: "123456789" },
          { label: "Localização", placeholder: "Lisboa, Portugal" },
        ].map((f) => (
          <div key={f.label}>
            <label style={s.label}>{f.label}</label>
            <input style={s.input} type={f.type || "text"} placeholder={f.placeholder} />
          </div>
        ))}
      </div>
      <div style={{ marginTop: "28px" }}>
        <button style={s.btn} onClick={() => onNavigate("onboardingEmpresa")}>Criar conta</button>
      </div>
    </div>
  </div>
);

// ─── ECRÃ 5: CRIAR CONTA INDIVIDUAL ──────────────────────────────────────────
const CriarContaIndividualScreen = ({ onNavigate }) => (
  <div style={s.screen}>
    <div style={s.topBar}>
      <button style={s.backBtn} onClick={() => onNavigate("tipoConta")}>‹</button>
      <MezaWordmark />
    </div>
    <div style={{ padding: "0 28px 28px" }}>
      <div style={{ display: "flex", borderBottom: `1px solid ${C.cremeDark}`, marginBottom: "24px" }}>
        <button style={{ flex: 1, padding: "12px", background: "none", border: "none", borderBottom: `2px solid ${C.verde}`, color: C.verde, fontFamily: "Georgia, serif", fontSize: "15px" }}>Individual</button>
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: "18px" }}>
        {[
          { label: "Nome", placeholder: "O teu nome" },
          { label: "Email", placeholder: "o_teu@email.com" },
          { label: "Palavra-passe", placeholder: "••••••••", type: "password" },
          { label: "Repetir palavra-passe", placeholder: "••••••••", type: "password" },
          { label: "Localização", placeholder: "Lisboa, Portugal" },
        ].map((f) => (
          <div key={f.label}>
            <label style={s.label}>{f.label}</label>
            <input style={s.input} type={f.type || "text"} placeholder={f.placeholder} />
          </div>
        ))}
      </div>
      <div style={{ marginTop: "28px" }}>
        <button style={{ ...s.btn, background: C.verde }} onClick={() => onNavigate("onboardingIndividual")}>Criar conta</button>
      </div>
    </div>
  </div>
);

// ─── ECRÃ 6: ESQUECEU PASSWORD ───────────────────────────────────────────────
const EsqueceuPasswordScreen = ({ onNavigate }) => (
  <div style={s.screen}>
    <div style={s.topBar}>
      <button style={s.backBtn} onClick={() => onNavigate("login")}>‹</button>
      <MezaWordmark />
    </div>
    <div style={{ padding: "40px 28px" }}>
      <h2 style={s.title}>Recuperar palavra-passe</h2>
      <p style={{ color: C.textoMuted, marginBottom: "32px", lineHeight: 1.5 }}>Introduz o teu email e enviamos um link para recuperares o acesso.</p>
      <div>
        <label style={s.label}>Email</label>
        <input style={s.input} placeholder="o_teu@email.com" />
      </div>
      <div style={{ marginTop: "32px" }}>
        <button style={s.btn} onClick={() => onNavigate("login")}>Enviar link de recuperação</button>
      </div>
    </div>
  </div>
);

// ─── ONBOARDING EMPRESA (4 ecrãs) ────────────────────────────────────────────
const OnboardingEmpresaScreen = ({ onNavigate }) => {
  const [passo, setPasso] = useState(0);
  const [setor, setSetor] = useState(null);
  const [config, setConfig] = useState({ empresa: "", localizacao: "", nrRefeicoes: "", equipa: "" });

  const setores = [
    { id: "restaurante", emoji: "🍽️", label: "Restaurante" },
    { id: "cafe", emoji: "☕", label: "Café / Pastelaria" },
    { id: "catering", emoji: "🍱", label: "Catering" },
    { id: "produtor", emoji: "🌾", label: "Produtor local" },
    { id: "retalhista", emoji: "🛒", label: "Retalho alimentar" },
    { id: "outro", emoji: "🏢", label: "Outro" },
  ];

  const features = [
    { emoji: "🛒", titulo: "Registo de compras", desc: "Adiciona compras manual ou por digitalização de recibo (PRO). Monitoriza origens e impacto." },
    { emoji: "🌍", titulo: "Pegada de carbono", desc: "Calcula o impacto ambiental do teu negócio — energia, alimentação, transportes e resíduos." },
    { emoji: "📊", titulo: "Relatórios", desc: "Relatórios semanais e mensais. O Relatório de Impacto (PRO) está disponível em breve." },
    { emoji: "📍", titulo: "Produtores locais", desc: "Descobre produtores perto de ti e recebe sugestões de compras mais sustentáveis." },
  ];

  const Dots = ({ total, atual }) => (
    <div style={{ display: "flex", gap: "6px", justifyContent: "center", margin: "20px 0" }}>
      {Array.from({ length: total }).map((_, i) => (
        <div key={i} style={{ width: i === atual ? "20px" : "8px", height: "8px", borderRadius: "4px", background: i === atual ? C.terracota : C.cremeDark, transition: "all 0.3s" }} />
      ))}
    </div>
  );

  return (
    <div style={{ ...s.screen, paddingBottom: 0 }}>
      {/* Passo 0 — Boas-vindas empresa */}
      {passo === 0 && (
        <div style={{ display: "flex", flexDirection: "column", minHeight: "844px" }}>
          <div style={{ background: `linear-gradient(160deg, ${C.terracota} 0%, ${C.terracotaDark} 100%)`, padding: "32px 32px 28px", display: "flex", flexDirection: "column", alignItems: "center", gap: "12px" }}>
            <div style={{ fontSize: "64px" }}>🏢</div>
            <MezaWordmark size="large" />
            <div style={{ color: "rgba(255,255,255,0.9)", fontSize: "22px", fontWeight: "700", textAlign: "center", marginTop: "8px" }}>
              Bem-vindo ao MeZa Empresas
            </div>
            <p style={{ color: "rgba(255,255,255,0.75)", fontSize: "14px", textAlign: "center", lineHeight: 1.6 }}>
              A plataforma que ajuda o teu negócio alimentar a medir, reduzir e comunicar o seu impacto ambiental.
            </p>
          </div>
          <div style={{ padding: "32px 28px", flex: 1 }}>
            <div style={{ display: "flex", flexDirection: "column", gap: "14px", marginBottom: "32px" }}>
              {[
                { emoji: "📉", texto: "Reduz a tua pegada de carbono" },
                { emoji: "💰", texto: "Poupa dinheiro ao evitar desperdício" },
                { emoji: "🌱", texto: "Comunica sustentabilidade aos clientes" },
                { emoji: "📋", texto: "Prepara-te para certificações ambientais" },
              ].map((item, i) => (
                <div key={i} style={{ display: "flex", gap: "14px", alignItems: "center" }}>
                  <span style={{ fontSize: "24px" }}>{item.emoji}</span>
                  <span style={{ fontSize: "15px", color: C.texto }}>{item.texto}</span>
                </div>
              ))}
            </div>
            <Dots total={4} atual={0} />
            <button style={s.btn} onClick={() => setPasso(1)}>Começar →</button>
          </div>
        </div>
      )}

      {/* Passo 1 — Setor */}
      {passo === 1 && (
        <div style={{ padding: "40px 24px", display: "flex", flexDirection: "column", minHeight: "844px" }}>
          <div style={{ marginBottom: "8px" }}>
            <div style={{ fontSize: "13px", color: C.textoMuted, marginBottom: "4px" }}>Passo 1 de 3</div>
            <div style={{ fontSize: "22px", fontWeight: "700", color: C.terracota, fontFamily: "Georgia, serif", marginBottom: "6px" }}>Qual é o teu setor?</div>
            <p style={{ color: C.textoMuted, fontSize: "14px" }}>Personalizamos a experiência com base no teu tipo de negócio.</p>
          </div>
          <Dots total={4} atual={1} />
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px", marginBottom: "24px" }}>
            {setores.map((s2) => (
              <button key={s2.id} onClick={() => setSetor(s2.id)}
                style={{ padding: "20px 12px", borderRadius: "16px", border: `2px solid ${setor === s2.id ? C.terracota : C.cremeDark}`, background: setor === s2.id ? C.cremeDark : C.branco, cursor: "pointer", display: "flex", flexDirection: "column", alignItems: "center", gap: "8px" }}>
                <span style={{ fontSize: "32px" }}>{s2.emoji}</span>
                <span style={{ fontSize: "13px", fontWeight: setor === s2.id ? "700" : "400", color: setor === s2.id ? C.terracota : C.texto }}>{s2.label}</span>
                {setor === s2.id && <span style={{ fontSize: "12px", color: C.terracota }}>✓</span>}
              </button>
            ))}
          </div>
          <div style={{ display: "flex", gap: "10px" }}>
            <button style={s.btnOutline} onClick={() => setPasso(0)}>‹ Voltar</button>
            <button style={{ ...s.btn, opacity: setor ? 1 : 0.5 }} onClick={() => setor && setPasso(2)}>Continuar →</button>
          </div>
        </div>
      )}

      {/* Passo 2 — Configuração */}
      {passo === 2 && (
        <div style={{ padding: "40px 24px", display: "flex", flexDirection: "column", minHeight: "844px" }}>
          <div style={{ marginBottom: "8px" }}>
            <div style={{ fontSize: "13px", color: C.textoMuted, marginBottom: "4px" }}>Passo 2 de 3</div>
            <div style={{ fontSize: "22px", fontWeight: "700", color: C.terracota, fontFamily: "Georgia, serif", marginBottom: "6px" }}>Conta-nos sobre o teu negócio</div>
            <p style={{ color: C.textoMuted, fontSize: "14px" }}>Estes dados ajudam-nos a calibrar os cálculos de impacto.</p>
          </div>
          <Dots total={4} atual={2} />
          <div style={{ display: "flex", flexDirection: "column", gap: "20px", marginBottom: "28px" }}>
            {[
              { key: "empresa", label: "Nome do negócio", placeholder: "Ex: Restaurante O Cantinho" },
              { key: "localizacao", label: "Localização", placeholder: "Ex: Lisboa, Portugal" },
              { key: "nrRefeicoes", label: "Nº de refeições/semana (aprox.)", placeholder: "Ex: 300" },
              { key: "equipa", label: "Nº de colaboradores", placeholder: "Ex: 8" },
            ].map((f) => (
              <div key={f.key}>
                <label style={s.label}>{f.label}</label>
                <input style={s.input} placeholder={f.placeholder} value={config[f.key]} onChange={e => setConfig(p => ({ ...p, [f.key]: e.target.value }))} />
              </div>
            ))}
          </div>
          <div style={{ display: "flex", gap: "10px" }}>
            <button style={s.btnOutline} onClick={() => setPasso(1)}>‹ Voltar</button>
            <button style={s.btn} onClick={() => setPasso(3)}>Continuar →</button>
          </div>
        </div>
      )}

      {/* Passo 3 — Features */}
      {passo === 3 && (
        <div style={{ display: "flex", flexDirection: "column", minHeight: "844px" }}>
          <div style={{ padding: "40px 24px 0" }}>
            <div style={{ fontSize: "13px", color: C.textoMuted, marginBottom: "4px" }}>Passo 3 de 3</div>
            <div style={{ fontSize: "22px", fontWeight: "700", color: C.terracota, fontFamily: "Georgia, serif", marginBottom: "6px" }}>O que tens à tua disposição</div>
            <p style={{ color: C.textoMuted, fontSize: "14px", marginBottom: "4px" }}>Explora tudo o que a MeZa tem para oferecer ao teu negócio.</p>
          </div>
          <Dots total={4} atual={3} />
          <div style={{ padding: "0 24px", display: "flex", flexDirection: "column", gap: "12px", marginBottom: "28px" }}>
            {features.map((f, i) => (
              <div key={i} style={{ ...s.card, display: "flex", gap: "14px", alignItems: "flex-start" }}>
                <span style={{ fontSize: "28px" }}>{f.emoji}</span>
                <div>
                  <div style={{ fontWeight: "700", color: C.texto, marginBottom: "4px" }}>{f.titulo}</div>
                  <div style={{ fontSize: "13px", color: C.textoMuted, lineHeight: 1.5 }}>{f.desc}</div>
                </div>
              </div>
            ))}
          </div>
          <div style={{ padding: "0 24px 32px" }}>
            <button style={s.btn} onClick={() => onNavigate("menu")}>🚀 Entrar na MeZa</button>
          </div>
        </div>
      )}
    </div>
  );
};

// ─── ONBOARDING INDIVIDUAL (4 ecrãs) ─────────────────────────────────────────
const OnboardingIndividualScreen = ({ onNavigate }) => {
  const [passo, setPasso] = useState(0);
  const [dieta, setDieta] = useState(null);
  const [motivacao, setMotivacao] = useState([]);

  const dietas = [
    { id: "omnivoro", emoji: "🍖", label: "Omnívoro" },
    { id: "flexitariano", emoji: "🥗", label: "Flexitariano" },
    { id: "vegetariano", emoji: "🥦", label: "Vegetariano" },
    { id: "vegan", emoji: "🌱", label: "Vegan" },
    { id: "sem_gluten", emoji: "🌾", label: "Sem glúten" },
    { id: "halal", emoji: "☪️", label: "Halal" },
  ];

  const motivacoes = [
    { id: "planeta", emoji: "🌍", label: "Cuidar do planeta" },
    { id: "saude", emoji: "💚", label: "Saúde e bem-estar" },
    { id: "poupar", emoji: "💰", label: "Poupar dinheiro" },
    { id: "aprender", emoji: "📚", label: "Aprender mais" },
    { id: "desperdicio", emoji: "♻️", label: "Reduzir desperdício" },
    { id: "local", emoji: "📍", label: "Apoiar o local" },
  ];

  const toggleMotivacao = (id) => setMotivacao(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);

  const Dots = ({ total, atual, cor }) => (
    <div style={{ display: "flex", gap: "6px", justifyContent: "center", margin: "20px 0" }}>
      {Array.from({ length: total }).map((_, i) => (
        <div key={i} style={{ width: i === atual ? "20px" : "8px", height: "8px", borderRadius: "4px", background: i === atual ? (cor || C.verde) : C.cremeDark, transition: "all 0.3s" }} />
      ))}
    </div>
  );

  return (
    <div style={{ ...s.screen, paddingBottom: 0 }}>

      {/* Passo 0 — Boas-vindas emotivo */}
      {passo === 0 && (
        <div style={{ display: "flex", flexDirection: "column", minHeight: "844px" }}>
          <div style={{ background: `linear-gradient(160deg, ${C.verde} 0%, #4A7A3D 100%)`, padding: "32px 32px 28px", display: "flex", flexDirection: "column", alignItems: "center", gap: "12px" }}>
            <div style={{ fontSize: "64px" }}>🌱</div>
            <MezaWordmark size="large" />
            <div style={{ color: "rgba(255,255,255,0.95)", fontSize: "22px", fontWeight: "700", textAlign: "center", marginTop: "8px" }}>
              Cada escolha importa.
            </div>
            <p style={{ color: "rgba(255,255,255,0.8)", fontSize: "15px", textAlign: "center", lineHeight: 1.7, fontStyle: "italic" }}>
              "O teu impacto começa com<br />o que escolhes pôr na mesa."
            </p>
          </div>
          <div style={{ padding: "32px 28px", flex: 1 }}>
            <p style={{ color: C.textoMuted, fontSize: "15px", lineHeight: 1.7, marginBottom: "24px", textAlign: "center" }}>
              A MeZa ajuda-te a fazer escolhas alimentares mais conscientes — sem complicações, sem julgamentos.
            </p>
            <div style={{ display: "flex", flexDirection: "column", gap: "12px", marginBottom: "32px" }}>
              {[
                { emoji: "🛒", texto: "Descobre produtores locais perto de ti" },
                { emoji: "📖", texto: "Aprende curiosidades sobre sustentabilidade" },
                { emoji: "🍽️", texto: "Receitas para aproveitares tudo ao máximo" },
                { emoji: "🌍", texto: "Vê o impacto real das tuas escolhas" },
              ].map((item, i) => (
                <div key={i} style={{ display: "flex", gap: "14px", alignItems: "center", padding: "10px 14px", background: C.cremeDark, borderRadius: "12px" }}>
                  <span style={{ fontSize: "22px" }}>{item.emoji}</span>
                  <span style={{ fontSize: "14px", color: C.texto }}>{item.texto}</span>
                </div>
              ))}
            </div>
            <Dots total={4} atual={0} cor={C.verde} />
            <button style={{ ...s.btn, background: C.verde }} onClick={() => setPasso(1)}>Começar →</button>
          </div>
        </div>
      )}

      {/* Passo 1 — Motivação */}
      {passo === 1 && (
        <div style={{ padding: "40px 24px", display: "flex", flexDirection: "column", minHeight: "844px" }}>
          <div style={{ marginBottom: "8px" }}>
            <div style={{ fontSize: "13px", color: C.textoMuted, marginBottom: "4px" }}>Passo 1 de 3</div>
            <div style={{ fontSize: "22px", fontWeight: "700", color: C.verde, fontFamily: "Georgia, serif", marginBottom: "6px" }}>O que te motiva?</div>
            <p style={{ color: C.textoMuted, fontSize: "14px" }}>Podes escolher mais do que uma opção.</p>
          </div>
          <Dots total={4} atual={1} cor={C.verde} />
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px", marginBottom: "28px" }}>
            {motivacoes.map((m) => {
              const ativa = motivacao.includes(m.id);
              return (
                <button key={m.id} onClick={() => toggleMotivacao(m.id)}
                  style={{ padding: "20px 12px", borderRadius: "16px", border: `2px solid ${ativa ? C.verde : C.cremeDark}`, background: ativa ? "#EEF6EC" : C.branco, cursor: "pointer", display: "flex", flexDirection: "column", alignItems: "center", gap: "8px" }}>
                  <span style={{ fontSize: "32px" }}>{m.emoji}</span>
                  <span style={{ fontSize: "12px", fontWeight: ativa ? "700" : "400", color: ativa ? C.verde : C.texto, textAlign: "center" }}>{m.label}</span>
                  {ativa && <span style={{ fontSize: "12px", color: C.verde }}>✓</span>}
                </button>
              );
            })}
          </div>
          <div style={{ display: "flex", gap: "10px" }}>
            <button style={s.btnOutline} onClick={() => setPasso(0)}>‹ Voltar</button>
            <button style={{ ...s.btn, background: C.verde, opacity: motivacao.length > 0 ? 1 : 0.5 }} onClick={() => motivacao.length > 0 && setPasso(2)}>Continuar →</button>
          </div>
        </div>
      )}

      {/* Passo 2 — Dieta */}
      {passo === 2 && (
        <div style={{ padding: "40px 24px", display: "flex", flexDirection: "column", minHeight: "844px" }}>
          <div style={{ marginBottom: "8px" }}>
            <div style={{ fontSize: "13px", color: C.textoMuted, marginBottom: "4px" }}>Passo 2 de 3</div>
            <div style={{ fontSize: "22px", fontWeight: "700", color: C.verde, fontFamily: "Georgia, serif", marginBottom: "6px" }}>Como te alimentas?</div>
            <p style={{ color: C.textoMuted, fontSize: "14px" }}>Personalizamos as sugestões e receitas para ti.</p>
          </div>
          <Dots total={4} atual={2} cor={C.verde} />
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px", marginBottom: "28px" }}>
            {dietas.map((d) => (
              <button key={d.id} onClick={() => setDieta(d.id)}
                style={{ padding: "20px 12px", borderRadius: "16px", border: `2px solid ${dieta === d.id ? C.verde : C.cremeDark}`, background: dieta === d.id ? "#EEF6EC" : C.branco, cursor: "pointer", display: "flex", flexDirection: "column", alignItems: "center", gap: "8px" }}>
                <span style={{ fontSize: "32px" }}>{d.emoji}</span>
                <span style={{ fontSize: "13px", fontWeight: dieta === d.id ? "700" : "400", color: dieta === d.id ? C.verde : C.texto }}>{d.label}</span>
                {dieta === d.id && <span style={{ fontSize: "12px", color: C.verde }}>✓</span>}
              </button>
            ))}
          </div>
          <div style={{ display: "flex", gap: "10px" }}>
            <button style={s.btnOutline} onClick={() => setPasso(1)}>‹ Voltar</button>
            <button style={{ ...s.btn, background: C.verde, opacity: dieta ? 1 : 0.5 }} onClick={() => dieta && setPasso(3)}>Continuar →</button>
          </div>
        </div>
      )}

      {/* Passo 3 — Pronto! */}
      {passo === 3 && (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "844px", padding: "40px 28px", textAlign: "center" }}>
          <div style={{ fontSize: "72px", marginBottom: "20px" }}>🌍</div>
          <MezaWordmark />
          <div style={{ fontSize: "24px", fontWeight: "700", color: C.verde, marginTop: "20px", marginBottom: "12px", fontFamily: "Georgia, serif" }}>
            Estás pronta, Cláudia!
          </div>
          <p style={{ color: C.textoMuted, fontSize: "15px", lineHeight: 1.7, marginBottom: "32px" }}>
            A tua jornada sustentável começa agora. Cada pequena escolha contribui para um mundo melhor.
          </p>
          <div style={{ background: C.cremeDark, borderRadius: "16px", padding: "20px", width: "100%", marginBottom: "32px", textAlign: "left" }}>
            <div style={{ fontWeight: "700", color: C.texto, marginBottom: "12px", fontSize: "14px" }}>A tua primeira missão 🎯</div>
            {[
              "Explora os produtores locais perto de ti",
              "Lê uma curiosidade sobre sustentabilidade",
              "Descobre as receitas anti-desperdício",
            ].map((m, i) => (
              <div key={i} style={{ display: "flex", gap: "10px", padding: "6px 0", fontSize: "13px", color: C.texto }}>
                <span style={{ color: C.verde }}>○</span> {m}
              </div>
            ))}
          </div>
          <Dots total={4} atual={3} cor={C.verde} />
          <button style={{ ...s.btn, background: C.verde, width: "100%" }} onClick={() => onNavigate("menuIndividual")}>
            🌱 Começar a explorar
          </button>
        </div>
      )}
    </div>
  );
};

// ─── DASHBOARD INDIVIDUAL ─────────────────────────────────────────────────────
const MenuIndividualScreen = ({ onNavigate, mao = "👋" }) => {
  const dica = { emoji: "🌊", texto: "Sabia que produzir 1 kg de café usa 18.900 L de água? Optar por café de produção local pode reduzir este impacto até 60%." };

  return (
    <div style={s.screen}>
      <div style={{ ...s.topBar, justifyContent: "center" }}>
        <MezaWordmark onClick={() => onNavigate("splash")} />
      </div>
      <div style={{ padding: "8px 20px 0" }}>

        {/* Saudação */}
        <div style={{ marginBottom: "20px" }}>
          <h2 style={{ fontSize: "22px", color: C.terracota, fontWeight: "700", marginBottom: "4px" }}>
            Olá, Cláudia! {mao}
          </h2>
          <p style={{ fontSize: "13px", color: C.textoMuted }}>O que queres explorar hoje?</p>
        </div>

        {/* Banner impacto pessoal */}
        <div style={{ background: `linear-gradient(135deg, ${C.verde}, #4A7A3D)`, borderRadius: "20px", padding: "18px 20px", marginBottom: "16px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div>
            <div style={{ fontSize: "12px", color: "rgba(255,255,255,0.75)", marginBottom: "4px" }}>O teu impacto este mês</div>
            <div style={{ fontSize: "22px", fontWeight: "700", color: C.branco }}>🌱 22 kg CO₂e evitados</div>
            <div style={{ fontSize: "11px", color: "rgba(255,255,255,0.7)", marginTop: "2px" }}>= 1 árvore plantada 🌳</div>
          </div>
          <button onClick={() => onNavigate("perfil")}
            style={{ background: "rgba(255,255,255,0.2)", border: "none", borderRadius: "12px", padding: "8px 12px", color: C.branco, fontSize: "12px", cursor: "pointer", fontFamily: "Georgia, serif" }}>
            Ver mais ›
          </button>
        </div>

        {/* Grid de ações principais */}
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px", marginBottom: "16px" }}>
          {[
            { emoji: "📍", titulo: "Perto de mim", desc: "Produtores locais e sustentáveis", screen: "sugestoes", cor: C.terracota },
            { emoji: "📖", titulo: "Aprender", desc: "Curiosidades e dicas do dia", screen: "curiosidades", cor: C.verde },
            { emoji: "🍽️", titulo: "Receitas", desc: "Anti-desperdício e deliciosas", screen: "receitas", cor: C.terracotaDark },
            { emoji: "🌍", titulo: "O meu impacto", desc: "Ver a minha pegada pessoal", screen: "pegadaIndividual", cor: C.verde },
          ].map((item, i) => (
            <button key={i} onClick={() => onNavigate(item.screen)}
              style={{ background: C.branco, border: `1.5px solid ${C.cremeDark}`, borderRadius: "18px", padding: "18px 14px", cursor: "pointer", textAlign: "left", display: "flex", flexDirection: "column", gap: "8px", boxShadow: "0 2px 8px rgba(0,0,0,0.05)" }}>
              <span style={{ fontSize: "28px" }}>{item.emoji}</span>
              <div style={{ fontWeight: "700", fontSize: "14px", color: item.cor }}>{item.titulo}</div>
              <div style={{ fontSize: "11px", color: C.textoMuted, lineHeight: 1.4 }}>{item.desc}</div>
            </button>
          ))}
        </div>

        {/* Dica do dia */}
        <div style={{ background: C.cremeDark, borderRadius: "16px", padding: "16px", marginBottom: "16px" }}>
          <div style={{ fontSize: "11px", color: C.terracota, fontWeight: "700", letterSpacing: "1px", marginBottom: "6px" }}>💡 DICA DO DIA</div>
          <p style={{ fontSize: "13px", color: C.texto, lineHeight: 1.6, margin: 0 }}>
            {dica.emoji} {dica.texto}
          </p>
          <button onClick={() => onNavigate("curiosidades")}
            style={{ background: "none", border: "none", color: C.terracota, fontSize: "12px", cursor: "pointer", marginTop: "8px", fontFamily: "Georgia, serif", fontWeight: "700", padding: 0 }}>
            Descobrir mais →
          </button>
        </div>

        {/* Missão da semana */}
        <div style={{ background: C.branco, borderRadius: "16px", padding: "16px", border: `1.5px solid ${C.cremeDark}` }}>
          <div style={{ fontSize: "11px", color: C.verde, fontWeight: "700", letterSpacing: "1px", marginBottom: "8px" }}>🎯 MISSÃO DA SEMANA</div>
          <div style={{ fontWeight: "700", color: C.texto, marginBottom: "6px", fontSize: "14px" }}>Compra a um produtor local</div>
          <p style={{ fontSize: "12px", color: C.textoMuted, lineHeight: 1.5, marginBottom: "10px" }}>Descobre um produtor perto de ti e faz a tua primeira compra sustentável desta semana.</p>
          <div style={{ background: C.cremeDark, borderRadius: "8px", height: "6px", marginBottom: "4px" }}>
            <div style={{ background: C.verde, borderRadius: "8px", height: "6px", width: "30%" }} />
          </div>
          <div style={{ fontSize: "11px", color: C.textoMuted }}>0 de 1 concluída</div>
        </div>
      </div>
      <BottomNav active="menu" onNavigate={(s) => {
        if (s === "menu") onNavigate("menuIndividual");
        else onNavigate(s);
      }} />
    </div>
  );
};

// ─── PEGADA INDIVIDUAL SIMPLIFICADA ──────────────────────────────────────────
const PegadaIndividualScreen = ({ onNavigate }) => {
  const [semana, setSemana] = useState({
    carne: false, peixe: false, lacticionios: false, vegetais: true, local: false, bio: false
  });

  return (
    <div style={s.screen}>
      <div style={s.topBar}>
        <button style={s.backBtn} onClick={() => onNavigate("menuIndividual")}>‹</button>
        <MezaWordmark onClick={() => onNavigate("menuIndividual")} />
      </div>
      <div style={{ padding: "0 24px" }}>
        <span style={s.sectionTitle}>A minha pegada pessoal</span>
        <p style={{ color: C.textoMuted, fontSize: "13px", lineHeight: 1.6, marginBottom: "20px" }}>
          O que comeste esta semana? Assinala as categorias — calculamos o teu impacto automaticamente.
        </p>

        {/* Seleção rápida */}
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "10px", marginBottom: "20px" }}>
          {[
            { key: "carne", emoji: "🥩", label: "Carne vermelha" },
            { key: "peixe", emoji: "🐟", label: "Peixe" },
            { key: "lacticionios", emoji: "🧀", label: "Laticínios" },
            { key: "vegetais", emoji: "🥦", label: "Vegetais" },
            { key: "local", emoji: "📍", label: "Produto local" },
            { key: "bio", emoji: "🌱", label: "Biológico" },
          ].map((item) => {
            const ativo = semana[item.key];
            return (
              <button key={item.key} onClick={() => setSemana(p => ({ ...p, [item.key]: !p[item.key] }))}
                style={{ padding: "14px 8px", borderRadius: "14px", border: `2px solid ${ativo ? C.verde : C.cremeDark}`, background: ativo ? "#EEF6EC" : C.branco, cursor: "pointer", display: "flex", flexDirection: "column", alignItems: "center", gap: "6px" }}>
                <span style={{ fontSize: "26px" }}>{item.emoji}</span>
                <span style={{ fontSize: "11px", color: ativo ? C.verde : C.textoMuted, fontWeight: ativo ? "700" : "400", textAlign: "center", lineHeight: 1.3 }}>{item.label}</span>
              </button>
            );
          })}
        </div>

        {/* Resultado estimado */}
        <div style={s.cardTerracota}>
          <div style={{ fontSize: "13px", opacity: 0.8, marginBottom: "4px" }}>Estimativa desta semana</div>
          <div style={{ fontSize: "28px", fontWeight: "700" }}>
            {(
              (semana.carne ? 8.2 : 0) +
              (semana.peixe ? 2.1 : 0) +
              (semana.lacticionios ? 3.4 : 0) +
              (semana.vegetais ? 0.8 : 0) -
              (semana.local ? 1.2 : 0) -
              (semana.bio ? 0.9 : 0)
            ).toFixed(1)} kg CO₂e
          </div>
          <div style={{ fontSize: "12px", opacity: 0.8, marginTop: "4px" }}>
            {semana.local || semana.bio ? "🌱 As tuas escolhas sustentáveis estão a fazer a diferença!" : "Experimenta adicionar produtos locais ou biológicos para reduzir o impacto."}
          </div>
        </div>

        {/* Dica personalizada */}
        {semana.carne && (
          <div style={{ background: "#FFF3CD", borderRadius: "14px", padding: "14px 16px", marginTop: "12px", borderLeft: `4px solid #F59E0B` }}>
            <div style={{ fontWeight: "700", color: "#92400E", fontSize: "13px", marginBottom: "4px" }}>💡 Dica personalizada</div>
            <p style={{ fontSize: "12px", color: "#92400E", lineHeight: 1.5, margin: 0 }}>
              Substituir carne vermelha por leguminosas 2x por semana pode reduzir a tua pegada alimentar em até 30%.
            </p>
          </div>
        )}

        <button style={{ ...s.btn, marginTop: "20px" }} onClick={() => onNavigate("menuIndividual")}>
          Guardar esta semana
        </button>
      </div>
    </div>
  );
};

// ─── ECRÃ 7: MENU PRINCIPAL (EMPRESA) ────────────────────────────────────────
const MenuScreen = ({ onNavigate, mao = "👋" }) => (
  <div style={s.screen}>
    <div style={{ ...s.topBar, justifyContent: "center" }}>
      <MezaWordmark onClick={() => onNavigate("menu")} />
    </div>
    <div style={{ padding: "12px 28px 0" }}>
      <h2 style={{ fontSize: "24px", color: C.terracota, fontWeight: "700", marginBottom: "28px" }}>
        Olá, Cláudia! {mao}
      </h2>
      <div style={{ display: "flex", flexDirection: "column", gap: "14px" }}>
        {[
          { label: "Adicionar compra", icon: "🛒", screen: "adicionarCompra1" },
          { label: "Ver última compra", icon: "📦", screen: "ultimaCompra" },
          { label: "A tua pegada de carbono", icon: "🌍", screen: "pegadaCarbono1" },
          { label: "Ver relatórios", icon: "📊", screen: "relatorios" },
          { label: "Receitas anti-desperdício", icon: "🍽️", screen: "receitas", pro: true },
        ].map((item) => (
          <button key={item.label} onClick={() => onNavigate(item.screen)}
            style={{ ...s.btnOutline, display: "flex", alignItems: "center", gap: "16px", padding: "18px 20px", textAlign: "left", fontSize: "15px", position: "relative" }}>
            <span style={{ fontSize: "24px" }}>{item.icon}</span>
            <span style={{ color: C.texto, flex: 1 }}>{item.label}</span>
            {item.pro && (
              <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: "2px" }}>
                <div style={{ background: C.terracota, borderRadius: "10px", padding: "2px 8px", fontSize: "10px", color: C.branco, fontWeight: "700" }}>PRO</div>
                <div style={{ fontSize: "9px", color: C.textoMuted, fontStyle: "italic" }}>Em breve</div>
              </div>
            )}
          </button>
        ))}
      </div>
    </div>
    <BottomNav active="menu" onNavigate={onNavigate} />
  </div>
);

// ─── ECRÃ 8: ADICIONAR COMPRA 1 ──────────────────────────────────────────────
const AdicionarCompra1Screen = ({ onNavigate }) => {
  const [showPremium, setShowPremium] = useState(false);
  return (
    <div style={s.screen}>
      <div style={s.topBar}>
        <button style={s.backBtn} onClick={() => onNavigate("menu")}>‹</button>
        <MezaWordmark onClick={() => onNavigate("menu")} />
      </div>
      <div style={{ padding: "0 28px" }}>
        <span style={s.sectionTitle}>Adicionar compra</span>
        <div style={{ display: "flex", flexDirection: "column", gap: "16px", marginTop: "20px" }}>

          {/* OPÇÃO PREMIUM — Digitalizar recibo */}
          <button onClick={() => setShowPremium(true)}
            style={{ background: C.branco, border: `1.5px solid ${C.cremeDark}`, borderRadius: "20px", padding: "0", cursor: "pointer", overflow: "hidden", position: "relative" }}>
            {/* Simulação de câmara */}
            <div style={{ background: C.escuro, height: "180px", display: "flex", alignItems: "center", justifyContent: "center", position: "relative" }}>
              {/* Cantos do viewfinder */}
              {[
                { top: "20px", left: "20px", borderTop: `3px solid ${C.branco}`, borderLeft: `3px solid ${C.branco}` },
                { top: "20px", right: "20px", borderTop: `3px solid ${C.branco}`, borderRight: `3px solid ${C.branco}` },
                { bottom: "20px", left: "20px", borderBottom: `3px solid ${C.branco}`, borderLeft: `3px solid ${C.branco}` },
                { bottom: "20px", right: "20px", borderBottom: `3px solid ${C.branco}`, borderRight: `3px solid ${C.branco}` },
              ].map((corner, i) => (
                <div key={i} style={{ position: "absolute", width: "24px", height: "24px", ...corner }} />
              ))}
              {/* Linha de scan animada */}
              <div style={{ position: "absolute", width: "70%", height: "2px", background: `${C.terracota}`, opacity: 0.8, top: "50%", left: "15%" }} />
              {/* Ícone câmara */}
              <div style={{ fontSize: "36px", opacity: 0.3 }}>📷</div>
              {/* Overlay cadeado */}
              <div style={{ position: "absolute", inset: 0, background: "rgba(0,0,0,0.55)", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "8px" }}>
                <div style={{ fontSize: "36px" }}>🔒</div>
                <div style={{ color: C.branco, fontSize: "13px", fontWeight: "700", fontFamily: "Georgia, serif" }}>Funcionalidade Premium</div>
              </div>
            </div>
            <div style={{ padding: "16px 20px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <div style={{ textAlign: "left" }}>
                <div style={{ fontSize: "15px", fontWeight: "700", color: C.texto }}>Digitalizar recibo</div>
                <div style={{ fontSize: "12px", color: C.textoMuted, marginTop: "2px" }}>Leitura automática por câmara</div>
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: "4px", alignItems: "flex-end" }}>
                <div style={{ background: C.terracota, borderRadius: "12px", padding: "4px 10px", fontSize: "11px", color: C.branco, fontWeight: "700" }}>PRO</div>
                <div style={{ fontSize: "10px", color: C.textoMuted, fontStyle: "italic" }}>Disponível em breve</div>
              </div>
            </div>
          </button>

          {/* OPÇÃO GRATUITA — Introduzir manualmente */}
          <button onClick={() => onNavigate("adicionarCompra2")}
            style={{ background: C.cremeDark, border: `1.5px solid ${C.terracota}`, borderRadius: "20px", padding: "24px 20px", cursor: "pointer", display: "flex", alignItems: "center", gap: "16px" }}>
            <div style={{ width: "56px", height: "56px", borderRadius: "14px", background: C.branco, display: "flex", alignItems: "center", justifyContent: "center", fontSize: "28px" }}>✏️</div>
            <div style={{ textAlign: "left" }}>
              <div style={{ fontSize: "15px", fontWeight: "700", color: C.texto }}>Introduzir manualmente</div>
              <div style={{ fontSize: "12px", color: C.textoMuted, marginTop: "2px" }}>Preenche os dados do produto</div>
            </div>
          </button>
        </div>
      </div>

      {/* Modal Premium */}
      {showPremium && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", display: "flex", alignItems: "flex-end", zIndex: 300 }}
          onClick={() => setShowPremium(false)}>
          <div style={{ background: C.fundo, borderRadius: "24px 24px 0 0", padding: "32px 28px", width: "100%", boxSizing: "border-box" }}
            onClick={(e) => e.stopPropagation()}>
            <div style={{ textAlign: "center", marginBottom: "20px" }}>
              <div style={{ fontSize: "48px", marginBottom: "12px" }}>🔒</div>
              <div style={{ fontSize: "20px", fontWeight: "700", color: C.terracota, fontFamily: "Georgia, serif", marginBottom: "8px" }}>Funcionalidade Premium</div>
              <p style={{ color: C.textoMuted, fontSize: "14px", lineHeight: 1.6 }}>
                A digitalização automática de recibos está disponível no plano MeZa Pro. Poupa tempo e regista as tuas compras em segundos.
              </p>
            </div>
            <div style={{ background: C.cremeDark, borderRadius: "16px", padding: "16px", marginBottom: "20px" }}>
              {["Digitalização automática de recibos", "Relatórios de impacto avançados", "Exportação de dados em PDF", "Suporte prioritário"].map((f, i) => (
                <div key={i} style={{ display: "flex", gap: "10px", padding: "6px 0", fontSize: "13px", color: C.texto }}>
                  <span style={{ color: C.verde }}>✓</span> {f}
                </div>
              ))}
            </div>
            <button style={s.btn}>Saber mais sobre o MeZa Pro</button>
            <button onClick={() => setShowPremium(false)}
              style={{ width: "100%", background: "none", border: "none", color: C.textoMuted, fontSize: "14px", cursor: "pointer", marginTop: "12px", fontFamily: "Georgia, serif" }}>
              Continuar com versão gratuita
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

// ─── ECRÃ 9: ADICIONAR COMPRA 2 ──────────────────────────────────────────────
const AdicionarCompra2Screen = ({ onNavigate }) => (
  <div style={s.screen}>
    <div style={s.topBar}>
      <button style={s.backBtn} onClick={() => onNavigate("adicionarCompra1")}>‹</button>
      <MezaWordmark onClick={() => onNavigate("menu")} />
    </div>
    <div style={{ padding: "0 28px" }}>
      <span style={s.sectionTitle}>Adicionar compra</span>
      <div style={{ display: "flex", flexDirection: "column", gap: "20px", marginTop: "8px" }}>
        {[
          { label: "Data da compra", placeholder: "dd/mm/aaaa", icon: "📅" },
          { label: "Tipo de produto", placeholder: "Ex: Tomates cherry" },
          { label: "Origem do produto", placeholder: "Ex: Espanha" },
          { label: "Peso (kg)", placeholder: "Ex: 5,00" },
          { label: "Prazo de validade", placeholder: "Ex: 3 a 7 dias" },
          { label: "Valor gasto (€)", placeholder: "Ex: 25,09" },
          { label: "Nome do estabelecimento", placeholder: "Ex: Mercado Global" },
        ].map((f) => (
          <div key={f.label}>
            <label style={s.label}>{f.label}</label>
            <div style={{ position: "relative" }}>
              <input style={s.input} placeholder={f.placeholder} />
              {f.icon && <span style={{ position: "absolute", right: 0, top: "14px" }}>{f.icon}</span>}
            </div>
          </div>
        ))}
        <button style={s.btnOutline} onClick={() => onNavigate("adicionarCompra2")}>+ Adicionar produto</button>
        <button style={s.btn} onClick={() => onNavigate("menu")}>Guardar compra</button>
      </div>
    </div>
    <BottomNav active="menu" onNavigate={onNavigate} />
  </div>
);

// ─── ECRÃ 10: ÚLTIMA COMPRA ───────────────────────────────────────────────────
const UltimaCompraScreen = ({ onNavigate }) => (
  <div style={s.screen}>
    <div style={s.topBar}>
      <button style={s.backBtn} onClick={() => onNavigate("menu")}>‹</button>
      <MezaWordmark onClick={() => onNavigate("menu")} />
    </div>
    <div style={{ padding: "0 28px" }}>
      <span style={s.sectionTitle}>Última compra</span>
      <div style={s.card}>
        {[
          { label: "Data da compra", value: "15/11/2024" },
          { label: "Tipo de produto", value: "Tomates cherry" },
          { label: "Origem do produto", value: "Espanha" },
          { label: "Peso", value: "5,00 kg" },
          { label: "Prazo de validade", value: "3 a 7 dias" },
          { label: "Valor gasto", value: "25,09 €" },
          { label: "Nome do estabelecimento", value: "Mercado Global" },
        ].map((item) => (
          <div key={item.label} style={{ display: "flex", justifyContent: "space-between", padding: "12px 0", borderBottom: `1px solid ${C.cremeDark}` }}>
            <span style={{ fontWeight: "700", color: C.texto, fontSize: "14px" }}>{item.label}</span>
            <span style={{ color: C.textoMuted, fontSize: "14px" }}>{item.value}</span>
          </div>
        ))}
      </div>
      <button style={s.btn} onClick={() => onNavigate("sugestoes")}>Ver sugestões sustentáveis</button>
    </div>
    <BottomNav active="menu" onNavigate={onNavigate} />
  </div>
);

// ─── ECRÃ 11: SUGESTÕES COM MAPA ─────────────────────────────────────────────
const SugestoesScreen = ({ onNavigate }) => {
  const [vista, setVista] = useState("mapa");
  const [produtorAtivo, setProdutorAtivo] = useState(null);

  const produtores = [
    { id: 1, nome: "Quinta da Oliveira", produto: "Tomates Cherry", dist: "2,3 km", co2: "1,1 kg CO₂e", poupanca: "2,1 kg CO₂e", agua: "80 L", tipo: "🍅", x: 52, y: 38, cor: C.verde },
    { id: 2, nome: "Granja Bio Sintra", produto: "Frango do campo", dist: "4,1 km", co2: "2,8 kg CO₂e", poupanca: "4,3 kg CO₂e", agua: "210 L", tipo: "🍗", x: 68, y: 55, cor: C.terracota },
    { id: 3, nome: "Cooperativa do Oeste", produto: "Batatas & Cenouras", dist: "5,8 km", co2: "0,4 kg CO₂e", poupanca: "0,8 kg CO₂e", agua: "35 L", tipo: "🥔", x: 30, y: 62, cor: C.verde },
    { id: 4, nome: "Herdade Ribatejo", produto: "Azeite biológico", dist: "8,2 km", co2: "0,9 kg CO₂e", poupanca: "1,4 kg CO₂e", agua: "55 L", tipo: "🫒", x: 72, y: 28, cor: C.terracotaDark },
    { id: 5, nome: "Viveiro da Serra", produto: "Ervas aromáticas", dist: "3,5 km", co2: "0,2 kg CO₂e", poupanca: "0,5 kg CO₂e", agua: "15 L", tipo: "🌿", x: 44, y: 70, cor: C.verde },
  ];

  const prodAtivo = produtores.find(p => p.id === produtorAtivo);

  return (
    <div style={{ ...s.screen, paddingBottom: "80px" }}>
      <div style={s.topBar}>
        <button style={s.backBtn} onClick={() => onNavigate("menu")}>‹</button>
        <MezaWordmark onClick={() => onNavigate("menu")} />
      </div>
      <div style={{ padding: "0 20px 12px" }}>
        {/* Localização */}
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "12px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "6px", color: C.terracota, fontSize: "14px", fontWeight: "700" }}>
            📍 Mafra, Lisboa
          </div>
          <div style={{ fontSize: "12px", color: C.textoMuted }}>{produtores.length} produtores locais encontrados</div>
        </div>

        {/* Toggle mapa / lista */}
        <div style={{ display: "flex", background: C.cremeDark, borderRadius: "12px", padding: "3px", marginBottom: "14px" }}>
          {[["mapa", "🗺️ Mapa"], ["lista", "☰ Lista"]].map(([id, label]) => (
            <button key={id} onClick={() => setVista(id)}
              style={{ flex: 1, padding: "8px", border: "none", borderRadius: "10px", background: vista === id ? C.branco : "transparent", color: vista === id ? C.terracota : C.textoMuted, fontFamily: "Georgia, serif", fontSize: "13px", fontWeight: vista === id ? "700" : "400", cursor: "pointer", boxShadow: vista === id ? "0 1px 4px rgba(0,0,0,0.1)" : "none", transition: "all 0.2s" }}>
              {label}
            </button>
          ))}
        </div>

        {vista === "mapa" ? (
          <>
            {/* Mapa simulado */}
            <div style={{ position: "relative", width: "100%", height: "260px", borderRadius: "20px", overflow: "hidden", marginBottom: "14px", border: `1px solid ${C.cremeDark}` }}>
              {/* Fundo do mapa */}
              <div style={{ position: "absolute", inset: 0, background: "linear-gradient(135deg, #e8f5e9 0%, #f1f8e9 30%, #e8f5e9 60%, #dcedc8 100%)" }} />

              {/* Estradas simuladas */}
              <svg style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }} viewBox="0 0 100 100" preserveAspectRatio="none">
                <line x1="0" y1="50" x2="100" y2="50" stroke="white" strokeWidth="1.2" opacity="0.8" />
                <line x1="50" y1="0" x2="50" y2="100" stroke="white" strokeWidth="1.2" opacity="0.8" />
                <line x1="0" y1="30" x2="100" y2="65" stroke="white" strokeWidth="0.8" opacity="0.6" />
                <line x1="20" y1="0" x2="80" y2="100" stroke="white" strokeWidth="0.8" opacity="0.6" />
                <line x1="0" y1="70" x2="100" y2="35" stroke="white" strokeWidth="0.7" opacity="0.5" />
                {/* Blocos de cidade */}
                {[[15,20,12,8],[60,15,10,10],[30,75,14,8],[65,68,12,10],[10,55,8,12],[78,45,10,8]].map(([x,y,w,h],i) => (
                  <rect key={i} x={x} y={y} width={w} height={h} fill="white" opacity="0.4" rx="1" />
                ))}
              </svg>

              {/* Círculo de raio em torno do utilizador */}
              <div style={{
                position: "absolute",
                left: "50%", top: "50%",
                transform: "translate(-50%, -50%)",
                width: "160px", height: "160px",
                borderRadius: "50%",
                border: `2px dashed ${C.verde}`,
                opacity: 0.35,
              }} />
              <div style={{
                position: "absolute",
                left: "50%", top: "50%",
                transform: "translate(-50%, -50%)",
                width: "100px", height: "100px",
                borderRadius: "50%",
                background: `${C.verde}15`,
                border: `1.5px solid ${C.verde}`,
                opacity: 0.4,
              }} />

              {/* Pin do utilizador */}
              <div style={{ position: "absolute", left: "50%", top: "50%", transform: "translate(-50%, -50%)", zIndex: 20, display: "flex", flexDirection: "column", alignItems: "center" }}>
                <div style={{ background: C.terracota, borderRadius: "50%", width: "28px", height: "28px", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "14px", boxShadow: "0 2px 8px rgba(0,0,0,0.25)", border: "2px solid white" }}>
                  👤
                </div>
                <div style={{ width: "2px", height: "6px", background: C.terracota }} />
                <div style={{ width: "6px", height: "3px", background: C.terracota, borderRadius: "50%" }} />
              </div>

              {/* Pins dos produtores */}
              {produtores.map((p) => (
                <button key={p.id} onClick={() => setProdutorAtivo(p.id === produtorAtivo ? null : p.id)}
                  style={{ position: "absolute", left: `${p.x}%`, top: `${p.y}%`, transform: "translate(-50%, -50%)", background: "none", border: "none", cursor: "pointer", zIndex: 15, display: "flex", flexDirection: "column", alignItems: "center" }}>
                  <div style={{ background: produtorAtivo === p.id ? p.cor : C.branco, borderRadius: "50%", width: produtorAtivo === p.id ? "36px" : "30px", height: produtorAtivo === p.id ? "36px" : "30px", display: "flex", alignItems: "center", justifyContent: "center", fontSize: produtorAtivo === p.id ? "18px" : "15px", boxShadow: `0 2px 8px rgba(0,0,0,0.2)`, border: `2px solid ${p.cor}`, transition: "all 0.2s" }}>
                    {p.tipo}
                  </div>
                  {produtorAtivo === p.id && (
                    <div style={{ background: C.branco, borderRadius: "8px", padding: "3px 7px", fontSize: "10px", fontWeight: "700", color: p.cor, boxShadow: "0 1px 4px rgba(0,0,0,0.15)", marginTop: "3px", whiteSpace: "nowrap" }}>
                      {p.dist}
                    </div>
                  )}
                </button>
              ))}

              {/* Label raio */}
              <div style={{ position: "absolute", bottom: "10px", right: "12px", fontSize: "10px", color: C.textoMuted, background: "rgba(255,255,255,0.85)", borderRadius: "8px", padding: "3px 8px" }}>
                Raio ~10 km
              </div>
            </div>

            {/* Card do produtor selecionado */}
            {prodAtivo ? (
              <div style={{ ...s.card, borderLeft: `4px solid ${prodAtivo.cor}`, animation: "fadeIn 0.2s" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "10px" }}>
                  <div>
                    <div style={{ fontSize: "20px", marginBottom: "4px" }}>{prodAtivo.tipo}</div>
                    <div style={{ fontWeight: "700", color: C.texto, fontSize: "15px" }}>{prodAtivo.nome}</div>
                    <div style={{ fontSize: "13px", color: C.textoMuted }}>{prodAtivo.produto}</div>
                  </div>
                  <div style={{ textAlign: "right" }}>
                    <div style={{ background: prodAtivo.cor, borderRadius: "12px", padding: "3px 10px", fontSize: "12px", color: C.branco, fontWeight: "700", marginBottom: "4px" }}>📍 {prodAtivo.dist}</div>
                    <div style={{ fontSize: "11px", color: C.verde }}>🌱 Poupa {prodAtivo.poupanca}</div>
                  </div>
                </div>
                <div style={{ display: "flex", gap: "8px", marginBottom: "12px" }}>
                  <div style={{ background: C.cremeDark, borderRadius: "8px", padding: "6px 10px", fontSize: "11px", color: C.texto, flex: 1, textAlign: "center" }}>
                    <div style={{ fontWeight: "700", color: C.terracota }}>{prodAtivo.co2}</div>
                    <div>pegada CO₂</div>
                  </div>
                  <div style={{ background: C.cremeDark, borderRadius: "8px", padding: "6px 10px", fontSize: "11px", color: C.texto, flex: 1, textAlign: "center" }}>
                    <div style={{ fontWeight: "700", color: C.terracota }}>{prodAtivo.agua}</div>
                    <div>água poupada</div>
                  </div>
                  <div style={{ background: C.cremeDark, borderRadius: "8px", padding: "6px 10px", fontSize: "11px", color: C.texto, flex: 1, textAlign: "center" }}>
                    <div style={{ fontWeight: "700", color: C.verde }}>{prodAtivo.dist}</div>
                    <div>distância</div>
                  </div>
                </div>
                <button style={s.btn} onClick={() => onNavigate("sugestoesGuardadas")}>♡ Guardar sugestão</button>
              </div>
            ) : (
              <div style={{ textAlign: "center", padding: "12px 0", color: C.textoMuted, fontSize: "13px" }}>
                Toca num produtor no mapa para ver detalhes 👆
              </div>
            )}
          </>
        ) : (
          /* Vista de lista */
          <div>
            {produtores.map((p, i) => (
              <div key={i} style={{ ...s.card, borderLeft: `4px solid ${p.cor}`, cursor: "pointer" }}
                onClick={() => { setVista("mapa"); setProdutorAtivo(p.id); }}>
                <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                  <div style={{ fontSize: "32px" }}>{p.tipo}</div>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: "700", color: C.texto, fontSize: "14px", marginBottom: "2px" }}>{p.nome}</div>
                    <div style={{ fontSize: "12px", color: C.textoMuted, marginBottom: "4px" }}>{p.produto}</div>
                    <div style={{ display: "flex", gap: "10px", fontSize: "11px" }}>
                      <span style={{ color: C.terracota }}>📍 {p.dist}</span>
                      <span style={{ color: C.verde }}>🌱 Poupa {p.poupanca}</span>
                    </div>
                  </div>
                  <span style={{ color: C.textoMuted, fontSize: "18px" }}>›</span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

// ─── ECRÃ 12: SUGESTÕES GUARDADAS ────────────────────────────────────────────
const SugestoesGuardadasScreen = ({ onNavigate }) => (
  <div style={s.screen}>
    <div style={s.topBar}>
      <button style={s.backBtn} onClick={() => onNavigate("sugestoes")}>‹</button>
      <MezaWordmark onClick={() => onNavigate("menu")} />
    </div>
    <div style={{ padding: "0 28px" }}>
      <span style={s.sectionTitle}>Sugestões guardadas</span>
      {[
        { produto: "Tomates Cherry", produtor: "Quinta da Oliveira", poupanca: "2,1 kg CO₂e" },
        { produto: "Frango do campo", produtor: "Granja Bio Sintra", poupanca: "4,3 kg CO₂e" },
        { produto: "Batatas", produtor: "Cooperativa do Oeste", poupanca: "0,8 kg CO₂e" },
      ].map((s2, i) => (
        <div key={i} style={{ ...s.card, borderLeft: `4px solid ${C.verde}` }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
            <div>
              <div style={{ fontWeight: "700", color: C.texto, marginBottom: "4px" }}>{s2.produto}</div>
              <div style={{ fontSize: "13px", color: C.textoMuted }}>{s2.produtor}</div>
              <div style={{ fontSize: "12px", color: C.verde, marginTop: "4px" }}>🌱 Poupa {s2.poupanca}</div>
            </div>
            <button style={{ background: "none", border: "none", fontSize: "20px", cursor: "pointer" }}>♡</button>
          </div>
        </div>
      ))}
    </div>
    <BottomNav active="sugestoes" onNavigate={onNavigate} />
  </div>
);

// ─── ECRÃ 12B: RECEITAS IA ───────────────────────────────────────────────────
const ReceitasScreen = ({ onNavigate }) => {
  const [showModal, setShowModal] = useState(false);
  const [notificado, setNotificado] = useState(false);

  // Inventário simulado — produtos a chegar ao fim da validade
  const inventario = [
    { nome: "Tomate", validade: "1 dia", emoji: "🍅", urgente: true },
    { nome: "Cebola", validade: "2 dias", emoji: "🧅", urgente: true },
    { nome: "Pepino", validade: "2 dias", emoji: "🥒", urgente: true },
    { nome: "Frango", validade: "3 dias", emoji: "🍗", urgente: false },
    { nome: "Batata", validade: "4 dias", emoji: "🥔", urgente: false },
    { nome: "Pimento", validade: "2 dias", emoji: "🫑", urgente: true },
  ];

  const receitasSugeridas = [
    {
      nome: "Gaspacho à portuguesa",
      ingredientes: ["Tomate", "Cebola", "Pepino", "Pimento"],
      tempo: "20 min",
      dificuldade: "Fácil",
      poupanca: "0,8 kg CO₂e evitado",
      descricao: "Sopa fria refrescante que aproveita os legumes maduros. Ideal para o verão!",
      emoji: "🥣",
      autor: "IA MeZa",
    },
    {
      nome: "Frango com tomate e cebola",
      ingredientes: ["Frango", "Tomate", "Cebola"],
      tempo: "35 min",
      dificuldade: "Médio",
      poupanca: "1,2 kg CO₂e evitado",
      descricao: "Receita clássica portuguesa que combina os ingredientes prestes a expirar.",
      emoji: "🍲",
      autor: "IA MeZa",
    },
    {
      nome: "Salada de pepino e tomate",
      ingredientes: ["Pepino", "Tomate", "Cebola"],
      tempo: "10 min",
      dificuldade: "Fácil",
      poupanca: "0,4 kg CO₂e evitado",
      descricao: "Simples, rápida e zero desperdício. Perfeita como acompanhamento.",
      emoji: "🥗",
      autor: "Comunidade",
    },
  ];

  return (
    <div style={s.screen}>
      <div style={s.topBar}>
        <button style={s.backBtn} onClick={() => onNavigate("menu")}>‹</button>
        <MezaWordmark onClick={() => onNavigate("menu")} />
      </div>
      <div style={{ padding: "0 28px" }}>

        {/* Header PRO */}
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "6px" }}>
          <span style={s.sectionTitle}>Receitas anti-desperdício</span>
          <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: "2px" }}>
            <div style={{ background: C.terracota, borderRadius: "10px", padding: "3px 10px", fontSize: "11px", color: C.branco, fontWeight: "700" }}>PRO</div>
            <div style={{ fontSize: "10px", color: C.textoMuted, fontStyle: "italic" }}>Disponível em breve</div>
          </div>
        </div>

        <p style={{ color: C.textoMuted, fontSize: "13px", lineHeight: 1.6, marginBottom: "20px" }}>
          Com base no teu inventário e nas datas de validade, a IA MeZa sugere receitas para evitar o desperdício.
        </p>

        {/* Alerta inventário */}
        <div style={{ background: "#FFF3CD", borderRadius: "14px", padding: "14px 16px", marginBottom: "20px", borderLeft: `4px solid #F59E0B` }}>
          <div style={{ fontWeight: "700", fontSize: "13px", color: "#92400E", marginBottom: "8px" }}>
            ⚠️ {inventario.filter(i => i.urgente).length} produtos a expirar em breve
          </div>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
            {inventario.filter(i => i.urgente).map((p, i) => (
              <div key={i} style={{ background: C.branco, borderRadius: "20px", padding: "4px 10px", fontSize: "12px", color: C.texto, border: `1px solid #F59E0B` }}>
                {p.emoji} {p.nome} <span style={{ color: "#EF4444", fontSize: "11px" }}>({p.validade})</span>
              </div>
            ))}
          </div>
        </div>

        {/* Receitas sugeridas */}
        <div style={{ fontWeight: "700", color: C.texto, fontSize: "14px", marginBottom: "12px" }}>
          ✨ Sugestões para hoje
        </div>

        {receitasSugeridas.map((receita, i) => (
          <div key={i} style={{ ...s.card, position: "relative", overflow: "hidden" }}>
            {/* Overlay PRO */}
            <div style={{ position: "absolute", inset: 0, background: "rgba(253,250,246,0.7)", backdropFilter: "blur(2px)", zIndex: 10, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", borderRadius: "16px", cursor: "pointer" }}
              onClick={() => setShowModal(true)}>
              <div style={{ fontSize: "28px", marginBottom: "6px" }}>🔒</div>
              <div style={{ fontSize: "12px", fontWeight: "700", color: C.terracota, fontFamily: "Georgia, serif" }}>Disponível em breve</div>
            </div>

            {/* Conteúdo da receita (visível por baixo do blur) */}
            <div style={{ display: "flex", gap: "12px", alignItems: "flex-start" }}>
              <div style={{ fontSize: "40px" }}>{receita.emoji}</div>
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: "700", color: C.texto, marginBottom: "4px", fontSize: "15px" }}>{receita.nome}</div>
                <div style={{ fontSize: "12px", color: C.textoMuted, marginBottom: "8px" }}>{receita.descricao}</div>
                <div style={{ display: "flex", flexWrap: "wrap", gap: "4px", marginBottom: "8px" }}>
                  {receita.ingredientes.map((ing, j) => (
                    <span key={j} style={{ background: C.cremeDark, borderRadius: "10px", padding: "2px 8px", fontSize: "11px", color: C.texto }}>
                      {ing}
                    </span>
                  ))}
                </div>
                <div style={{ display: "flex", gap: "12px", fontSize: "12px" }}>
                  <span style={{ color: C.textoMuted }}>⏱ {receita.tempo}</span>
                  <span style={{ color: C.textoMuted }}>👨‍🍳 {receita.dificuldade}</span>
                  <span style={{ color: C.verde }}>🌱 {receita.poupanca}</span>
                </div>
                <div style={{ marginTop: "6px", fontSize: "11px", color: C.textoMuted }}>
                  {receita.autor === "IA MeZa" ? "✨ Sugerido pela IA MeZa" : "👥 Partilhado pela comunidade"}
                </div>
              </div>
            </div>
          </div>
        ))}

        {/* Submeter receita da comunidade — também PRO */}
        <div style={{ ...s.card, border: `1.5px dashed ${C.verde}`, background: "transparent", opacity: 0.7 }}>
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <span style={{ fontSize: "28px" }}>👥</span>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: "700", color: C.verde, fontSize: "14px", marginBottom: "2px" }}>Partilhar a tua receita</div>
              <div style={{ fontSize: "12px", color: C.textoMuted }}>Contribui para a comunidade MeZa com as tuas receitas anti-desperdício</div>
            </div>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "2px" }}>
              <div style={{ background: C.terracota, borderRadius: "10px", padding: "2px 8px", fontSize: "10px", color: C.branco, fontWeight: "700" }}>PRO</div>
              <div style={{ fontSize: "9px", color: C.textoMuted, fontStyle: "italic" }}>Em breve</div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal PRO */}
      {showModal && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", display: "flex", alignItems: "flex-end", zIndex: 300 }}
          onClick={() => setShowModal(false)}>
          <div style={{ background: C.fundo, borderRadius: "24px 24px 0 0", padding: "32px 28px", width: "100%", boxSizing: "border-box" }}
            onClick={(e) => e.stopPropagation()}>
            <div style={{ textAlign: "center", marginBottom: "20px" }}>
              <div style={{ fontSize: "48px", marginBottom: "12px" }}>🍽️</div>
              <div style={{ fontSize: "20px", fontWeight: "700", color: C.terracota, fontFamily: "Georgia, serif", marginBottom: "8px" }}>
                Receitas IA — Em breve
              </div>
              <p style={{ color: C.textoMuted, fontSize: "14px", lineHeight: 1.6 }}>
                A IA MeZa vai analisar o teu inventário e sugerir receitas personalizadas antes que os produtos expirem, evitando desperdício e poupando dinheiro.
              </p>
            </div>
            <div style={{ background: C.cremeDark, borderRadius: "16px", padding: "16px", marginBottom: "20px" }}>
              {[
                "Receitas geradas por IA com base no teu inventário",
                "Alertas quando produtos estão prestes a expirar",
                "Receitas da comunidade MeZa",
                "Partilha as tuas próprias receitas",
                "Cálculo do CO₂e evitado por receita",
              ].map((f, i) => (
                <div key={i} style={{ display: "flex", gap: "10px", padding: "6px 0", fontSize: "13px", color: C.texto }}>
                  <span style={{ color: C.verde }}>✓</span> {f}
                </div>
              ))}
            </div>
            {!notificado ? (
              <>
                <button style={s.btn} onClick={() => setNotificado(true)}>
                  🔔 Notifica-me quando estiver disponível
                </button>
                <button onClick={() => setShowModal(false)}
                  style={{ width: "100%", background: "none", border: "none", color: C.textoMuted, fontSize: "14px", cursor: "pointer", marginTop: "12px", fontFamily: "Georgia, serif" }}>
                  Fechar
                </button>
              </>
            ) : (
              <div style={{ textAlign: "center" }}>
                <div style={{ fontSize: "52px", marginBottom: "12px" }}>🎉</div>
                <div style={{ fontSize: "18px", fontWeight: "700", color: C.verde, fontFamily: "Georgia, serif", marginBottom: "8px" }}>
                  Ficaste na lista!
                </div>
                <p style={{ color: C.textoMuted, fontSize: "14px", lineHeight: 1.6, marginBottom: "24px" }}>
                  Assim que as Receitas IA estiverem disponíveis, serás uma das primeiras a saber. Obrigada por fazeres parte da MeZa! 🌱
                </p>
                <button style={s.btn} onClick={() => { setShowModal(false); setNotificado(false); }}>
                  Fechar
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

// ─── ECRÃ 13: RELATORIOS ─────────────────────────────────────────────────────
const RelatoriosScreen = ({ onNavigate }) => {
  const [tab, setTab] = useState("semanal");
  const [showRelatorio, setShowRelatorio] = useState(false);
  const [showModalImpacto, setShowModalImpacto] = useState(false);
  const [notificado, setNotificado] = useState(false);

  return (
    <div style={s.screen}>
      <div style={s.topBar}>
        <button style={s.backBtn} onClick={() => onNavigate("menu")}>‹</button>
        <MezaWordmark onClick={() => onNavigate("menu")} />
      </div>
      <div style={{ padding: "0 28px" }}>
        <div style={{ display: "flex", borderBottom: `1px solid ${C.cremeDark}`, marginBottom: "24px" }}>
          {[["semanal", "Relatório semanal"], ["mensal", "Relatórios mensais"]].map(([id, label]) => (
            <button key={id} onClick={() => setTab(id)} style={{ flex: 1, padding: "12px", background: "none", border: "none", borderBottom: tab === id ? `2px solid ${C.terracota}` : "2px solid transparent", color: tab === id ? C.terracota : C.textoMuted, fontFamily: "Georgia, serif", fontSize: "13px", cursor: "pointer" }}>
              {label}
            </button>
          ))}
        </div>
        {tab === "semanal" ? (
          <div>
            <div style={s.cardTerracota}>
              <div style={{ fontSize: "13px", opacity: 0.8, marginBottom: "8px" }}>Semana de 25 a 30 de novembro</div>
              <div style={{ fontSize: "28px", fontWeight: "700" }}>12,4 kg CO₂e</div>
              <div style={{ fontSize: "13px", opacity: 0.8, marginTop: "4px" }}>↓ 8% face à semana anterior</div>
            </div>
            <div style={s.card}>
              <div style={{ fontWeight: "700", marginBottom: "12px", color: C.texto }}>Distribuição</div>
              {[["Alimentação", "7,2 kg", "58%"], ["Energia", "3,1 kg", "25%"], ["Transportes", "2,1 kg", "17%"]].map(([cat, val, pct]) => (
                <div key={cat} style={{ marginBottom: "12px" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", fontSize: "13px", marginBottom: "4px" }}>
                    <span style={{ color: C.texto }}>{cat}</span>
                    <span style={{ color: C.terracota, fontWeight: "700" }}>{val}</span>
                  </div>
                  <div style={{ background: C.cremeDark, borderRadius: "4px", height: "6px" }}>
                    <div style={{ background: C.terracota, borderRadius: "4px", height: "6px", width: pct }} />
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div>
            <div style={{ marginBottom: "20px" }}>
              <div style={{ fontSize: "12px", color: C.textoMuted, marginBottom: "8px" }}>Escolher data</div>
              <div style={{ border: `1px solid ${C.cremeDark}`, borderRadius: "12px", padding: "12px" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "12px" }}>
                  <span style={{ fontSize: "13px", cursor: "pointer" }}>‹</span>
                  <span style={{ fontWeight: "700", fontSize: "14px" }}>Novembro 2024</span>
                  <span style={{ fontSize: "13px", cursor: "pointer" }}>›</span>
                </div>
                <div style={{ display: "grid", gridTemplateColumns: "repeat(7,1fr)", gap: "4px", textAlign: "center", fontSize: "12px" }}>
                  {["D","S","T","Q","Q","S","S"].map((d, i) => <div key={i} style={{ color: C.textoMuted, padding: "2px" }}>{d}</div>)}
                  {Array.from({ length: 30 }, (_, i) => (
                    <div key={i} style={{ padding: "4px 2px", borderRadius: "50%", background: i + 1 === 30 ? C.terracota : "transparent", color: i + 1 === 30 ? C.branco : C.texto, cursor: "pointer", fontSize: "12px" }}>{i + 1}</div>
                  ))}
                </div>
              </div>
            </div>

            {/* Relatório standard — clicável, abre preview */}
            <button onClick={() => setShowRelatorio(true)} style={{ ...s.cardTerracota, width: "100%", textAlign: "left", cursor: "pointer", border: "none" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div>
                  <div style={{ fontSize: "14px", fontWeight: "700" }}>Relatório standard</div>
                  <div style={{ fontSize: "12px", opacity: 0.8 }}>Novembro 2024 — toca para ver</div>
                </div>
                <span style={{ fontSize: "24px" }}>📥</span>
              </div>
            </button>

            {/* Relatório de impacto — PRO, abre modal */}
            <button onClick={() => setShowModalImpacto(true)}
              style={{ ...s.card, width: "100%", textAlign: "left", cursor: "pointer", border: `1.5px dashed ${C.cremeDark}`, opacity: 0.85 }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div>
                  <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "4px" }}>
                    <div style={{ fontSize: "14px", fontWeight: "700", color: C.textoMuted }}>Relatório de impacto</div>
                    <div style={{ background: C.terracota, borderRadius: "10px", padding: "2px 8px", fontSize: "10px", color: C.branco, fontWeight: "700" }}>PRO</div>
                  </div>
                  <div style={{ fontSize: "12px", color: C.textoMuted, fontStyle: "italic" }}>🔒 Disponível em breve — toca para saber mais</div>
                </div>
                <span style={{ fontSize: "28px" }}>🔒</span>
              </div>
            </button>
          </div>
        )}
      </div>

      {/* Modal relatório standard */}
      {showRelatorio && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", display: "flex", alignItems: "flex-end", zIndex: 300 }}
          onClick={() => setShowRelatorio(false)}>
          <div style={{ background: C.fundo, borderRadius: "24px 24px 0 0", padding: "32px 28px", width: "100%", boxSizing: "border-box", maxHeight: "80vh", overflowY: "auto" }}
            onClick={(e) => e.stopPropagation()}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
              <div>
                <div style={{ fontSize: "18px", fontWeight: "700", color: C.terracota, fontFamily: "Georgia, serif" }}>📊 Relatório standard</div>
                <div style={{ fontSize: "12px", color: C.textoMuted }}>Novembro 2024</div>
              </div>
              <button onClick={() => setShowRelatorio(false)} style={{ background: C.cremeDark, border: "none", borderRadius: "50%", width: "32px", height: "32px", cursor: "pointer", fontSize: "16px" }}>✕</button>
            </div>
            <div style={s.cardTerracota}>
              <div style={{ fontSize: "13px", opacity: 0.8, marginBottom: "4px" }}>Total mensal</div>
              <div style={{ fontSize: "32px", fontWeight: "700" }}>48,6 kg CO₂e</div>
              <div style={{ fontSize: "13px", opacity: 0.8, marginTop: "4px" }}>↓ 12% face ao mês anterior</div>
            </div>
            <div style={s.card}>
              <div style={{ fontWeight: "700", marginBottom: "12px", color: C.texto }}>Distribuição por categoria</div>
              {[["Alimentação", "28,1 kg", "58%"], ["Energia", "12,2 kg", "25%"], ["Transportes", "8,3 kg", "17%"]].map(([cat, val, pct]) => (
                <div key={cat} style={{ marginBottom: "12px" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", fontSize: "13px", marginBottom: "4px" }}>
                    <span style={{ color: C.texto }}>{cat}</span>
                    <span style={{ color: C.terracota, fontWeight: "700" }}>{val}</span>
                  </div>
                  <div style={{ background: C.cremeDark, borderRadius: "4px", height: "6px" }}>
                    <div style={{ background: C.terracota, borderRadius: "4px", height: "6px", width: pct }} />
                  </div>
                </div>
              ))}
            </div>
            <div style={s.card}>
              <div style={{ fontWeight: "700", marginBottom: "12px", color: C.texto }}>Compras do mês</div>
              {[["Tomates cherry", "1,1 kg CO₂e"], ["Frango do campo", "3,2 kg CO₂e"], ["Batatas", "0,4 kg CO₂e"], ["Azeite", "0,9 kg CO₂e"]].map(([prod, co2]) => (
                <div key={prod} style={{ display: "flex", justifyContent: "space-between", padding: "8px 0", borderBottom: `1px solid ${C.cremeDark}`, fontSize: "13px" }}>
                  <span style={{ color: C.texto }}>{prod}</span>
                  <span style={{ color: C.textoMuted }}>{co2}</span>
                </div>
              ))}
            </div>
            <button style={s.btn}>📥 Descarregar PDF</button>
            <button onClick={() => setShowRelatorio(false)}
              style={{ width: "100%", background: "none", border: "none", color: C.textoMuted, fontSize: "14px", cursor: "pointer", marginTop: "12px", fontFamily: "Georgia, serif" }}>
              Fechar
            </button>
          </div>
        </div>
      )}

      {/* Modal relatório de impacto PRO */}
      {showModalImpacto && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", display: "flex", alignItems: "flex-end", zIndex: 300 }}
          onClick={() => setShowModalImpacto(false)}>
          <div style={{ background: C.fundo, borderRadius: "24px 24px 0 0", padding: "32px 28px", width: "100%", boxSizing: "border-box" }}
            onClick={(e) => e.stopPropagation()}>
            {!notificado ? (
              <>
                <div style={{ textAlign: "center", marginBottom: "20px" }}>
                  <div style={{ fontSize: "48px", marginBottom: "12px" }}>📈</div>
                  <div style={{ fontSize: "20px", fontWeight: "700", color: C.terracota, fontFamily: "Georgia, serif", marginBottom: "8px" }}>
                    Relatório de Impacto — Em breve
                  </div>
                  <p style={{ color: C.textoMuted, fontSize: "14px", lineHeight: 1.6 }}>
                    O relatório de impacto vai além dos dados básicos — mostra o teu contributo real para a sustentabilidade e gera documentos prontos a partilhar com clientes, parceiros ou para certificações.
                  </p>
                </div>
                <div style={{ background: C.cremeDark, borderRadius: "16px", padding: "16px", marginBottom: "20px" }}>
                  {[
                    "Análise detalhada do impacto ambiental por categoria",
                    "Comparação com benchmarks do setor",
                    "Metas de redução personalizadas com IA",
                    "Relatório PDF pronto para certificações",
                    "Partilha com clientes e parceiros",
                    "Histórico de evolução mês a mês",
                  ].map((f, i) => (
                    <div key={i} style={{ display: "flex", gap: "10px", padding: "6px 0", fontSize: "13px", color: C.texto }}>
                      <span style={{ color: C.verde }}>✓</span> {f}
                    </div>
                  ))}
                </div>
                <button style={s.btn} onClick={() => setNotificado(true)}>
                  🔔 Notifica-me quando estiver disponível
                </button>
                <button onClick={() => setShowModalImpacto(false)}
                  style={{ width: "100%", background: "none", border: "none", color: C.textoMuted, fontSize: "14px", cursor: "pointer", marginTop: "12px", fontFamily: "Georgia, serif" }}>
                  Fechar
                </button>
              </>
            ) : (
              <div style={{ textAlign: "center" }}>
                <div style={{ fontSize: "52px", marginBottom: "12px" }}>🎉</div>
                <div style={{ fontSize: "18px", fontWeight: "700", color: C.verde, fontFamily: "Georgia, serif", marginBottom: "8px" }}>
                  Ficaste na lista!
                </div>
                <p style={{ color: C.textoMuted, fontSize: "14px", lineHeight: 1.6, marginBottom: "24px" }}>
                  Assim que o Relatório de Impacto estiver disponível, serás uma das primeiras a saber. Obrigada por fazeres parte da MeZa! 🌱
                </p>
                <button style={s.btn} onClick={() => { setShowModalImpacto(false); setNotificado(false); }}>
                  Fechar
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

// ─── ECRÃ 14: PEGADA CARBONO 1 ────────────────────────────────────────────────
const PegadaCarbono1Screen = ({ onNavigate }) => (
  <div style={s.screen}>
    <div style={s.topBar}>
      <button style={s.backBtn} onClick={() => onNavigate("menu")}>‹</button>
      <MezaWordmark onClick={() => onNavigate("menu")} />
    </div>
    <div style={{ padding: "0 28px" }}>
      <h2 style={{ ...s.title, fontSize: "24px", color: C.terracota }}>Calculadora de Pegada de Carbono Alimentar</h2>
      <p style={{ color: C.textoMuted, lineHeight: 1.6, fontSize: "14px", marginBottom: "24px" }}>
        A pegada de carbono mede a quantidade total de gases com efeito de estufa (principalmente CO₂, CH₄ e N₂O) libertados para a atmosfera como resultado das tuas atividades.
      </p>
      <p style={{ color: C.textoMuted, lineHeight: 1.6, fontSize: "14px" }}>
        Ajuda-te a compreender de onde vêm as emissões, como reduzi-las e como tornar as tuas operações mais sustentáveis e eficientes.
      </p>
      <div style={{ textAlign: "center", marginTop: "40px" }}>
        <button onClick={() => onNavigate("pegadaCarbono2")} style={{ width: "48px", height: "48px", borderRadius: "50%", background: C.cremeDark, border: "none", cursor: "pointer", fontSize: "20px" }}>›</button>
      </div>
    </div>
    <BottomNav active="menu" onNavigate={onNavigate} />
  </div>
);

// ─── ECRÃ 15: PEGADA CARBONO SUBMENU ─────────────────────────────────────────
const PegadaCarbono2Screen = ({ onNavigate }) => (
  <div style={s.screen}>
    <div style={s.topBar}>
      <button style={s.backBtn} onClick={() => onNavigate("pegadaCarbono1")}>‹</button>
      <MezaWordmark onClick={() => onNavigate("menu")} />
    </div>
    <div style={{ padding: "0 28px" }}>
      <span style={s.sectionTitle}>Pegada de carbono</span>
      <p style={{ color: C.textoMuted, fontSize: "13px", marginBottom: "20px" }}>Seleciona uma categoria para calcular:</p>
      <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
        {[
          { icon: "ℹ️", label: "Informação geral", screen: "infoGeral" },
          { icon: "⚡", label: "Consumo de energia", screen: "energiaUso" },
          { icon: "🥦", label: "Alimentação e ingredientes", screen: "alimentacao" },
          { icon: "🚚", label: "Transportes e entregas", screen: "transportes" },
          { icon: "♻️", label: "Gestão de resíduos", screen: "residuos" },
          { icon: "🌍", label: "Pegada total de carbono", screen: "pegadaTotal" },
        ].map((item) => (
          <button key={item.label} onClick={() => onNavigate(item.screen)}
            style={{ ...s.btnOutline, display: "flex", alignItems: "center", gap: "14px", padding: "16px 20px", textAlign: "left" }}>
            <span style={{ fontSize: "22px" }}>{item.icon}</span>
            <span style={{ color: C.texto, fontSize: "14px" }}>{item.label}</span>
            <span style={{ marginLeft: "auto", color: C.textoMuted }}>›</span>
          </button>
        ))}
      </div>
    </div>
    <BottomNav active="menu" onNavigate={onNavigate} />
  </div>
);

// ─── ECRÃ 16: INFO GERAL ──────────────────────────────────────────────────────
const InfoGeralScreen = ({ onNavigate }) => (
  <div style={s.screen}>
    <div style={s.topBar}>
      <button style={s.backBtn} onClick={() => onNavigate("pegadaCarbono2")}>‹</button>
      <MezaWordmark onClick={() => onNavigate("menu")} />
    </div>
    <div style={{ padding: "0 28px" }}>
      <span style={s.sectionTitle}>Informação geral</span>
      {[
        { label: "Nome do estabelecimento", placeholder: "Restaurante Exemplo" },
        { label: "Tipo de negócio", placeholder: "Ex: Restaurante" },
        { label: "Número de refeições/semana", placeholder: "Ex: 500" },
        { label: "Número de funcionários", placeholder: "Ex: 12" },
      ].map((f) => (
        <div key={f.label} style={{ marginBottom: "20px" }}>
          <label style={s.label}>{f.label}</label>
          <input style={s.input} placeholder={f.placeholder} />
        </div>
      ))}
      <button style={s.btn} onClick={() => onNavigate("pegadaCarbono2")}>Guardar</button>
    </div>
    <BottomNav active="menu" onNavigate={onNavigate} />
  </div>
);

// ─── ECRÃ 17: ENERGIA ─────────────────────────────────────────────────────────
const EnergiaScreen = ({ onNavigate }) => (
  <div style={s.screen}>
    <div style={s.topBar}>
      <button style={s.backBtn} onClick={() => onNavigate("pegadaCarbono2")}>‹</button>
      <MezaWordmark onClick={() => onNavigate("menu")} />
    </div>
    <div style={{ padding: "0 28px" }}>
      <span style={s.sectionTitle}>Consumo de energia</span>
      {[
        { label: "Eletricidade mensal (kWh)", placeholder: "Ex: 2400" },
        { label: "Gás natural mensal (m³)", placeholder: "Ex: 180" },
        { label: "Fonte de energia renovável?", placeholder: "Sim / Não" },
      ].map((f) => (
        <div key={f.label} style={{ marginBottom: "20px" }}>
          <label style={s.label}>{f.label}</label>
          <input style={s.input} placeholder={f.placeholder} />
        </div>
      ))}
      <div style={{ ...s.cardTerracota, marginTop: "8px" }}>
        <div style={{ fontSize: "13px", opacity: 0.8, marginBottom: "4px" }}>Estimativa atual</div>
        <div style={{ fontSize: "28px", fontWeight: "700" }}>13,0 tons CO₂e/ano</div>
      </div>
      <button style={s.btn} onClick={() => onNavigate("pegadaCarbono2")}>Guardar</button>
    </div>
    <BottomNav active="menu" onNavigate={onNavigate} />
  </div>
);

// ─── ECRÃ 18: PEGADA TOTAL ────────────────────────────────────────────────────
const PegadaTotalScreen = ({ onNavigate }) => (
  <div style={s.screen}>
    <div style={s.topBar}>
      <button style={s.backBtn} onClick={() => onNavigate("pegadaCarbono2")}>‹</button>
      <MezaWordmark onClick={() => onNavigate("menu")} />
    </div>
    <div style={{ padding: "0 28px" }}>
      <span style={s.sectionTitle}>Pegada total de carbono</span>
      <div style={s.cardTerracota}>
        <div style={{ fontWeight: "700", marginBottom: "16px", fontSize: "16px" }}>Emissões (tons CO₂e/ano)</div>
        {[["Energia", "13,0"], ["Alimentação", "75,2"], ["Transportes", "7,3"], ["Resíduos", "1,3"]].map(([cat, val]) => (
          <div key={cat} style={{ display: "flex", justifyContent: "space-between", padding: "6px 0", borderBottom: "1px solid rgba(255,255,255,0.2)" }}>
            <span style={{ fontSize: "14px" }}>{cat}</span>
            <span style={{ fontWeight: "700" }}>{val}</span>
          </div>
        ))}
        <div style={{ display: "flex", justifyContent: "space-between", marginTop: "12px", fontWeight: "700", fontSize: "16px" }}>
          <span>Total</span>
          <span>96,8 tons CO₂e/ano</span>
        </div>
      </div>
      <div style={{ textAlign: "center", marginTop: "12px" }}>
        <button onClick={() => onNavigate("melhorias")} style={{ width: "48px", height: "48px", borderRadius: "50%", background: C.cremeDark, border: "none", cursor: "pointer", fontSize: "20px" }}>›</button>
      </div>
    </div>
    <BottomNav active="menu" onNavigate={onNavigate} />
  </div>
);

// ─── ECRÃ 19: MELHORIAS ───────────────────────────────────────────────────────
const MelhoriasScreen = ({ onNavigate }) => (
  <div style={s.screen}>
    <div style={s.topBar}>
      <button style={s.backBtn} onClick={() => onNavigate("pegadaTotal")}>‹</button>
      <MezaWordmark onClick={() => onNavigate("menu")} />
    </div>
    <div style={{ padding: "0 28px" }}>
      <span style={s.sectionTitle}>Exemplo de melhoria</span>
      <p style={{ color: C.textoMuted, fontSize: "14px", lineHeight: 1.6, marginBottom: "20px" }}>
        Ao substituir metade da carne de vaca, adotar renováveis e fazer compostagem:
      </p>
      <div style={{ fontSize: "14px", color: C.texto, marginBottom: "20px", lineHeight: 1.8 }}>
        <div>→ <strong>Novo total ≈ 66 tons CO₂e/ano</strong></div>
        <div>→ = 2,64 kg CO₂e/refeição (↓32% de melhoria)</div>
      </div>
      <div style={{ display: "flex", gap: "16px", marginBottom: "28px" }}>
        <div style={{ ...s.cardTerracota, flex: 1, textAlign: "center" }}>
          <div style={{ fontSize: "13px", marginBottom: "8px" }}>Agora</div>
          <div style={{ fontSize: "36px", fontWeight: "700" }}>96,8</div>
          <div style={{ fontSize: "12px", opacity: 0.8 }}>tons CO₂e/ano</div>
        </div>
        <div style={{ ...s.cardTerracota, flex: 1, textAlign: "center", background: C.verde }}>
          <div style={{ fontSize: "13px", marginBottom: "8px" }}>Depois</div>
          <div style={{ fontSize: "36px", fontWeight: "700" }}>66</div>
          <div style={{ fontSize: "12px", opacity: 0.8 }}>tons CO₂e/ano</div>
        </div>
      </div>
      <button style={s.btn} onClick={() => onNavigate("menu")}>Concluído</button>
    </div>
    <BottomNav active="menu" onNavigate={onNavigate} />
  </div>
);

// ─── ECRÃ 20: NOTIFICAÇÕES ────────────────────────────────────────────────────
const NotificacoesScreen = ({ onNavigate }) => (
  <div style={s.screen}>
    <div style={s.topBar}>
      <button style={s.backBtn} onClick={() => onNavigate("menu")}>‹</button>
      <MezaWordmark onClick={() => onNavigate("menu")} />
    </div>
    <div style={{ padding: "0 28px" }}>
      <span style={s.sectionTitle}>Notificações</span>
      {[
        { icon: "⏰", title: "Lembrete!", msg: "Ainda tens 5 kg de cebolas para usar! Consulta as nossas sugestões de receitas para evitar desperdício.", time: "30 min", dot: true },
        { icon: "♡", title: "Vê as tuas sugestões!", msg: "Os teus favoritos estão à espera! Não te esqueças de consultar e escolher a melhor opção.", time: "1 dia", dot: true },
        { icon: "📅", title: "Lembrete do momento!", msg: "Os relatórios mensais estão disponíveis! Descarrega o teu agora.", time: "3 dias" },
        { icon: "🌍", title: "Está na hora de calcular a tua pegada!", msg: "Calcula o teu consumo e vê o que podes melhorar.", time: "3 dias" },
      ].map((n, i) => (
        <div key={i} style={{ ...s.card, position: "relative", borderLeft: n.dot ? `4px solid ${C.terracota}` : "4px solid transparent" }}>
          <div style={{ display: "flex", gap: "12px" }}>
            <span style={{ fontSize: "22px" }}>{n.icon}</span>
            <div style={{ flex: 1 }}>
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "4px" }}>
                <span style={{ fontWeight: "700", fontSize: "14px", color: C.texto }}>{n.title}</span>
                <span style={{ fontSize: "11px", color: C.textoMuted }}>{n.time}</span>
              </div>
              <p style={{ fontSize: "13px", color: C.textoMuted, lineHeight: 1.5, margin: 0 }}>{n.msg}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
    <BottomNav active="notificacoes" onNavigate={onNavigate} />
  </div>
);

// ─── ECRÃ 21: PERFIL ──────────────────────────────────────────────────────────
const PerfilScreen = ({ onNavigate, tomPele, setTomPele }) => {
  const [showTomPele, setShowTomPele] = useState(false);
  const [showNotif, setShowNotif] = useState(false);
  const [showMetas, setShowMetas] = useState(false);
  const [showDieta, setShowDieta] = useState(false);
  const [showAlergias, setShowAlergias] = useState(false);
  const [showImpacto, setShowImpacto] = useState(false);
  const [showConquistas, setShowConquistas] = useState(false);
  const [showPartilhar, setShowPartilhar] = useState(false);
  const [showConta, setShowConta] = useState(false);
  const [showPrivacidade, setShowPrivacidade] = useState(false);
  const [notifSettings, setNotifSettings] = useState({ validades: true, relatorios: true, sugestoes: false, dicas: true });
  const [dietaAtiva, setDietaAtiva] = useState("omnivoro");
  const [alergias, setAlergias] = useState(["Lactose"]);
  const [metaCO2, setMetaCO2] = useState(20);
  const [conquistaNotif, setConquistaNotif] = useState(false);

  const tons = [
    { id: "default", label: "Padrão", mao: "👋",   cor: "#F5DEB3" },
    { id: "t1",      label: "Tom 1",  mao: "👋🏻", cor: "#FDDBB4" },
    { id: "t2",      label: "Tom 2",  mao: "👋🏼", cor: "#E8B88A" },
    { id: "t3",      label: "Tom 3",  mao: "👋🏽", cor: "#C68642" },
    { id: "t4",      label: "Tom 4",  mao: "👋🏾", cor: "#8D5524" },
    { id: "t5",      label: "Tom 5",  mao: "👋🏿", cor: "#4A2912" },
  ];
  const tomAtivo = tons.find(t => t.id === tomPele) || tons[0];

  const dietas = [
    { id: "omnivoro",    label: "Omnívoro",    emoji: "🍖" },
    { id: "flexitariano",label: "Flexitariano",emoji: "🥗" },
    { id: "vegetariano", label: "Vegetariano", emoji: "🥦" },
    { id: "vegan",       label: "Vegan",       emoji: "🌱" },
    { id: "sem_gluten",  label: "Sem glúten",  emoji: "🌾" },
    { id: "halal",       label: "Halal",       emoji: "☪️" },
  ];

  const alergiasOpts = ["Glúten","Lactose","Ovos","Frutos secos","Marisco","Soja","Peixe","Amendoim"];

  const conquistas = [
    { emoji: "🌱", titulo: "Primeiros passos", desc: "Primeira compra registada", conquistado: true, data: "Nov 2024" },
    { emoji: "♻️", titulo: "Zero desperdício", desc: "Usaste todas as sugestões de receitas numa semana", conquistado: true, data: "Nov 2024" },
    { emoji: "🌍", titulo: "100 kg CO₂e evitados", desc: "Evitaste 100 kg de CO₂e desde que usas a MeZa", conquistado: true, data: "Nov 2024" },
    { emoji: "🥇", titulo: "Produtor local", desc: "Compraste a 5 produtores locais diferentes", conquistado: false, progresso: "3/5" },
    { emoji: "📊", titulo: "Analista verde", desc: "Descarregaste 3 relatórios mensais", conquistado: false, progresso: "1/3" },
    { emoji: "🔥", titulo: "30 dias seguidos", desc: "Registaste compras 30 dias consecutivos", conquistado: false, progresso: "12/30" },
    { emoji: "💚", titulo: "Embaixador MeZa", desc: "Partilhaste o teu impacto nas redes sociais", conquistado: false, pro: true },
    { emoji: "🏆", titulo: "Sustentabilidade total", desc: "Atingiste todas as metas num mês", conquistado: false, pro: true },
  ];

  const secaoRow = (icon, titulo, desc, onPress, extra) => (
    <button onClick={onPress} style={{ width: "100%", background: C.branco, border: "none", borderRadius: "14px", padding: "16px", marginBottom: "10px", display: "flex", alignItems: "center", gap: "14px", cursor: "pointer", textAlign: "left", boxShadow: "0 2px 8px rgba(0,0,0,0.05)" }}>
      <span style={{ fontSize: "22px", width: "32px", textAlign: "center" }}>{icon}</span>
      <div style={{ flex: 1 }}>
        <div style={{ fontWeight: "700", fontSize: "14px", color: C.texto }}>{titulo}</div>
        {desc && <div style={{ fontSize: "12px", color: C.textoMuted, marginTop: "2px" }}>{desc}</div>}
      </div>
      {extra}
      <span style={{ color: C.textoMuted, fontSize: "18px" }}>›</span>
    </button>
  );

  const Modal = ({ show, onClose, children }) => show ? (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.55)", display: "flex", alignItems: "flex-end", zIndex: 300 }} onClick={onClose}>
      <div style={{ background: C.fundo, borderRadius: "24px 24px 0 0", padding: "28px 24px", width: "100%", boxSizing: "border-box", maxHeight: "85vh", overflowY: "auto" }} onClick={e => e.stopPropagation()}>
        {children}
      </div>
    </div>
  ) : null;

  const ModalHeader = ({ emoji, titulo, sub, onClose }) => (
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "20px" }}>
      <div>
        <div style={{ fontSize: "32px", marginBottom: "4px" }}>{emoji}</div>
        <div style={{ fontSize: "18px", fontWeight: "700", color: C.terracota, fontFamily: "Georgia, serif" }}>{titulo}</div>
        {sub && <div style={{ fontSize: "12px", color: C.textoMuted, marginTop: "2px" }}>{sub}</div>}
      </div>
      <button onClick={onClose} style={{ background: C.cremeDark, border: "none", borderRadius: "50%", width: "32px", height: "32px", cursor: "pointer", fontSize: "16px", flexShrink: 0 }}>✕</button>
    </div>
  );

  return (
    <div style={s.screen}>
      <div style={s.topBar}>
        <button style={s.backBtn} onClick={() => onNavigate("menu")}>‹</button>
        <MezaWordmark onClick={() => onNavigate("menu")} />
      </div>
      <div style={{ padding: "0 20px" }}>

        {/* Idioma */}
        <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px", marginBottom: "16px" }}>
          <button style={{ background: "none", border: `1px solid ${C.cremeDark}`, borderRadius: "20px", padding: "4px 12px", fontSize: "12px", cursor: "pointer" }}>🇵🇹 PT</button>
          <button style={{ background: "none", border: `1px solid ${C.cremeDark}`, borderRadius: "20px", padding: "4px 12px", fontSize: "12px", cursor: "pointer" }}>🇬🇧 EN</button>
        </div>

        {/* Avatar + nome */}
        <div style={{ display: "flex", alignItems: "center", gap: "16px", marginBottom: "24px" }}>
          <div style={{ width: "64px", height: "64px", borderRadius: "50%", background: C.terracota, display: "flex", alignItems: "center", justifyContent: "center", fontSize: "30px" }}>
            {tomAtivo.mao}
          </div>
          <div>
            <div style={{ fontWeight: "700", fontSize: "18px", color: C.texto }}>Cláudia Oliveira</div>
            <div style={{ fontSize: "12px", color: C.textoMuted }}>Titular da conta · {dietas.find(d=>d.id===dietaAtiva)?.emoji} {dietas.find(d=>d.id===dietaAtiva)?.label}</div>
            <div style={{ fontSize: "11px", color: C.verde, marginTop: "2px" }}>🏆 3 conquistas desbloqueadas</div>
          </div>
          <button style={{ marginLeft: "auto", background: "none", border: "none", cursor: "pointer", fontSize: "18px" }}>✏️</button>
        </div>

        {/* Impacto acumulado — mini banner */}
        <button onClick={() => setShowImpacto(true)} style={{ width: "100%", background: `linear-gradient(135deg, ${C.terracota}, ${C.verde})`, border: "none", borderRadius: "16px", padding: "16px 20px", marginBottom: "20px", cursor: "pointer", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div style={{ textAlign: "left" }}>
            <div style={{ fontSize: "12px", color: "rgba(255,255,255,0.8)", marginBottom: "2px" }}>O meu impacto acumulado</div>
            <div style={{ fontSize: "20px", fontWeight: "700", color: C.branco }}>🌍 148,3 kg CO₂e evitados</div>
          </div>
          <span style={{ color: "rgba(255,255,255,0.8)", fontSize: "20px" }}>›</span>
        </button>

        {/* Secções */}
        <div style={{ fontSize: "11px", color: C.textoMuted, letterSpacing: "1px", marginBottom: "8px", marginLeft: "4px" }}>PREFERÊNCIAS</div>
        {secaoRow("🎨", "Tom de pele dos emojis", `Atual: ${tomAtivo.mao} — Representa-te como quiseres`, () => setShowTomPele(true))}
        {secaoRow("🍽️", "Tipo de dieta", dietas.find(d=>d.id===dietaAtiva)?.label, () => setShowDieta(true))}
        {secaoRow("⚠️", "Alergias e restrições", alergias.length > 0 ? alergias.join(", ") : "Nenhuma definida", () => setShowAlergias(true))}
        {secaoRow("🎯", "Metas de sustentabilidade", `Reduzir ${metaCO2}% de CO₂e este mês`, () => setShowMetas(true))}
        {secaoRow("🔔", "Notificações", "Gerir alertas e lembretes", () => setShowNotif(true))}

        <div style={{ fontSize: "11px", color: C.textoMuted, letterSpacing: "1px", marginBottom: "8px", marginLeft: "4px", marginTop: "8px" }}>CONQUISTAS & PARTILHA</div>
        {secaoRow("🏆", "As minhas conquistas", "3 desbloqueadas · 5 em progresso", () => setShowConquistas(true), <div style={{ background: C.terracota, borderRadius: "10px", padding: "2px 8px", fontSize: "11px", color: C.branco, fontWeight: "700" }}>3</div>)}
        {secaoRow("📤", "Partilhar o meu impacto", "Gerar cartão para redes sociais", () => setShowPartilhar(true), <div style={{ background: C.terracota, borderRadius: "10px", padding: "2px 8px", fontSize: "10px", color: C.branco, fontWeight: "700" }}>PRO</div>)}

        <div style={{ fontSize: "11px", color: C.textoMuted, letterSpacing: "1px", marginBottom: "8px", marginLeft: "4px", marginTop: "8px" }}>CONTA & PRIVACIDADE</div>
        {secaoRow("🔑", "Alterar email / palavra-passe", "xxxxxx_S@gmail.com", () => setShowConta(true))}
        {secaoRow("🛡️", "Privacidade e dados", "RGPD · Ver e apagar os meus dados", () => setShowPrivacidade(true))}
        {secaoRow("👥", "Perfis", "Adicionar ou remover perfis", () => {})}

        <button style={{ background: "none", border: "none", color: "#E53E3E", fontSize: "14px", cursor: "pointer", width: "100%", textAlign: "center", padding: "16px", fontFamily: "Georgia, serif" }}>
          Terminar sessão
        </button>
      </div>

      {/* ── MODAL: Tom de pele ── */}
      <Modal show={showTomPele} onClose={() => setShowTomPele(false)}>
        <ModalHeader emoji="🎨" titulo="Tom de pele dos emojis" sub="Representa-te como quiseres 🌍" onClose={() => setShowTomPele(false)} />
        <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", justifyContent: "center", marginBottom: "20px" }}>
          {tons.map((tom) => (
            <button key={tom.id} onClick={() => setTomPele(tom.id)}
              style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "6px", background: tomPele === tom.id ? C.cremeDark : "transparent", border: `2px solid ${tomPele === tom.id ? C.terracota : "transparent"}`, borderRadius: "14px", padding: "12px", cursor: "pointer" }}>
              <span style={{ fontSize: "32px" }}>{tom.mao}</span>
              <div style={{ width: "18px", height: "18px", borderRadius: "50%", background: tom.cor, border: `2px solid ${tomPele === tom.id ? C.terracota : C.cremeDark}` }} />
              {tomPele === tom.id && <span style={{ fontSize: "11px", color: C.terracota, fontWeight: "700" }}>✓</span>}
            </button>
          ))}
        </div>
        <div style={{ background: C.cremeDark, borderRadius: "12px", padding: "12px", textAlign: "center", marginBottom: "16px", fontSize: "14px", color: C.texto }}>
          Pré-visualização: Olá, Cláudia {tomAtivo.mao}
        </div>
        <button style={s.btn} onClick={() => setShowTomPele(false)}>Guardar</button>
      </Modal>

      {/* ── MODAL: Notificações ── */}
      <Modal show={showNotif} onClose={() => setShowNotif(false)}>
        <ModalHeader emoji="🔔" titulo="Notificações" sub="Escolhe o que queres receber" onClose={() => setShowNotif(false)} />
        {[
          { id: "validades", label: "Alertas de validade", desc: "Quando produtos estão prestes a expirar" },
          { id: "relatorios", label: "Relatórios disponíveis", desc: "Quando o relatório mensal está pronto" },
          { id: "sugestoes", label: "Novas sugestões", desc: "Produtores locais perto de ti" },
          { id: "dicas", label: "Dica da semana", desc: "Curiosidades e dicas de sustentabilidade" },
        ].map((n) => (
          <div key={n.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "14px 0", borderBottom: `1px solid ${C.cremeDark}` }}>
            <div>
              <div style={{ fontWeight: "700", fontSize: "14px", color: C.texto }}>{n.label}</div>
              <div style={{ fontSize: "12px", color: C.textoMuted }}>{n.desc}</div>
            </div>
            <button onClick={() => setNotifSettings(prev => ({ ...prev, [n.id]: !prev[n.id] }))}
              style={{ width: "48px", height: "26px", borderRadius: "13px", background: notifSettings[n.id] ? C.verde : C.cremeDark, border: "none", cursor: "pointer", position: "relative", transition: "background 0.2s", flexShrink: 0 }}>
              <div style={{ width: "20px", height: "20px", borderRadius: "50%", background: C.branco, position: "absolute", top: "3px", left: notifSettings[n.id] ? "25px" : "3px", transition: "left 0.2s", boxShadow: "0 1px 3px rgba(0,0,0,0.2)" }} />
            </button>
          </div>
        ))}
        <button style={{ ...s.btn, marginTop: "20px" }} onClick={() => setShowNotif(false)}>Guardar</button>
      </Modal>

      {/* ── MODAL: Metas ── */}
      <Modal show={showMetas} onClose={() => setShowMetas(false)}>
        <ModalHeader emoji="🎯" titulo="Metas de sustentabilidade" sub="Define os teus objetivos mensais" onClose={() => setShowMetas(false)} />
        <div style={{ marginBottom: "20px" }}>
          <div style={{ fontWeight: "700", color: C.texto, marginBottom: "8px", fontSize: "14px" }}>Redução de CO₂e este mês</div>
          <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "8px" }}>
            <input type="range" min="5" max="50" value={metaCO2} onChange={e => setMetaCO2(Number(e.target.value))}
              style={{ flex: 1, accentColor: C.terracota }} />
            <div style={{ background: C.terracota, color: C.branco, borderRadius: "10px", padding: "4px 12px", fontWeight: "700", fontSize: "16px", minWidth: "52px", textAlign: "center" }}>{metaCO2}%</div>
          </div>
          <div style={{ background: C.cremeDark, borderRadius: "10px", padding: "10px 14px", fontSize: "13px", color: C.textoMuted }}>
            Com esta meta, o teu objetivo é passar de <strong style={{ color: C.texto }}>96,8 tons CO₂e/ano</strong> para <strong style={{ color: C.verde }}>{(96.8 * (1 - metaCO2/100)).toFixed(1)} tons CO₂e/ano</strong>.
          </div>
        </div>
        <div style={{ marginBottom: "20px" }}>
          <div style={{ fontWeight: "700", color: C.texto, marginBottom: "12px", fontSize: "14px" }}>Outras metas</div>
          {[
            { label: "Comprar a pelo menos 2 produtores locais por mês", checked: true },
            { label: "Reduzir desperdício alimentar em 30%", checked: true },
            { label: "Registar todas as compras semanalmente", checked: false },
            { label: "Consultar sugestões sustentáveis antes de comprar", checked: false },
          ].map((m, i) => (
            <div key={i} style={{ display: "flex", gap: "12px", alignItems: "center", padding: "10px 0", borderBottom: `1px solid ${C.cremeDark}` }}>
              <div style={{ width: "20px", height: "20px", borderRadius: "5px", background: m.checked ? C.verde : C.cremeDark, display: "flex", alignItems: "center", justifyContent: "center", fontSize: "12px", flexShrink: 0 }}>
                {m.checked && "✓"}
              </div>
              <span style={{ fontSize: "13px", color: C.texto }}>{m.label}</span>
            </div>
          ))}
        </div>
        <button style={s.btn} onClick={() => setShowMetas(false)}>Guardar metas</button>
      </Modal>

      {/* ── MODAL: Dieta ── */}
      <Modal show={showDieta} onClose={() => setShowDieta(false)}>
        <ModalHeader emoji="🍽️" titulo="Tipo de dieta" sub="Personalizamos as sugestões e receitas" onClose={() => setShowDieta(false)} />
        <div style={{ display: "flex", flexDirection: "column", gap: "10px", marginBottom: "20px" }}>
          {dietas.map((d) => (
            <button key={d.id} onClick={() => setDietaAtiva(d.id)}
              style={{ display: "flex", alignItems: "center", gap: "14px", padding: "14px 16px", borderRadius: "14px", border: `2px solid ${dietaAtiva === d.id ? C.terracota : C.cremeDark}`, background: dietaAtiva === d.id ? C.cremeDark : C.branco, cursor: "pointer" }}>
              <span style={{ fontSize: "24px" }}>{d.emoji}</span>
              <span style={{ fontWeight: dietaAtiva === d.id ? "700" : "400", color: dietaAtiva === d.id ? C.terracota : C.texto, fontSize: "15px" }}>{d.label}</span>
              {dietaAtiva === d.id && <span style={{ marginLeft: "auto", color: C.terracota, fontSize: "18px" }}>✓</span>}
            </button>
          ))}
        </div>
        <button style={s.btn} onClick={() => setShowDieta(false)}>Guardar</button>
      </Modal>

      {/* ── MODAL: Alergias ── */}
      <Modal show={showAlergias} onClose={() => setShowAlergias(false)}>
        <ModalHeader emoji="⚠️" titulo="Alergias e restrições" sub="Usamos esta informação nas sugestões e receitas" onClose={() => setShowAlergias(false)} />
        <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", marginBottom: "20px" }}>
          {alergiasOpts.map((a) => {
            const ativa = alergias.includes(a);
            return (
              <button key={a} onClick={() => setAlergias(prev => ativa ? prev.filter(x => x !== a) : [...prev, a])}
                style={{ padding: "8px 16px", borderRadius: "20px", border: `2px solid ${ativa ? C.terracota : C.cremeDark}`, background: ativa ? C.cremeDark : C.branco, color: ativa ? C.terracota : C.texto, fontSize: "13px", fontWeight: ativa ? "700" : "400", cursor: "pointer" }}>
                {ativa ? "✓ " : ""}{a}
              </button>
            );
          })}
        </div>
        {alergias.length > 0 && (
          <div style={{ background: "#FFF3CD", borderRadius: "10px", padding: "10px 14px", fontSize: "12px", color: "#92400E", marginBottom: "16px" }}>
            ⚠️ Selecionadas: {alergias.join(", ")}
          </div>
        )}
        <button style={s.btn} onClick={() => setShowAlergias(false)}>Guardar</button>
      </Modal>

      {/* ── MODAL: Impacto acumulado ── */}
      <Modal show={showImpacto} onClose={() => setShowImpacto(false)}>
        <ModalHeader emoji="🌍" titulo="O meu impacto acumulado" sub="Desde que usas a MeZa" onClose={() => setShowImpacto(false)} />
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px", marginBottom: "20px" }}>
          {[
            { valor: "148,3 kg", label: "CO₂e evitado", emoji: "🌿", cor: C.verde },
            { valor: "2.840 L", label: "Água poupada", emoji: "💧", cor: "#3B82F6" },
            { valor: "23 kg", label: "Desperdício evitado", emoji: "♻️", cor: C.terracota },
            { valor: "18", label: "Produtores locais", emoji: "📍", cor: C.terracotaDark },
          ].map((item, i) => (
            <div key={i} style={{ background: C.cremeDark, borderRadius: "14px", padding: "16px", textAlign: "center" }}>
              <div style={{ fontSize: "24px", marginBottom: "4px" }}>{item.emoji}</div>
              <div style={{ fontSize: "20px", fontWeight: "700", color: item.cor }}>{item.valor}</div>
              <div style={{ fontSize: "11px", color: C.textoMuted }}>{item.label}</div>
            </div>
          ))}
        </div>
        <div style={{ ...s.cardTerracota, marginBottom: "16px" }}>
          <div style={{ fontSize: "13px", opacity: 0.85, marginBottom: "4px" }}>Equivalente a...</div>
          <div style={{ fontSize: "15px", fontWeight: "700" }}>🌳 Plantares 7 árvores adultas</div>
          <div style={{ fontSize: "13px", opacity: 0.8, marginTop: "4px" }}>ou não conduzires 592 km de carro</div>
        </div>
        <div style={{ background: C.cremeDark, borderRadius: "12px", padding: "14px", marginBottom: "16px" }}>
          <div style={{ fontWeight: "700", color: C.texto, marginBottom: "10px", fontSize: "14px" }}>Evolução mensal</div>
          {[["Set", 8], ["Out", 14], ["Nov", 22]].map(([mes, val]) => (
            <div key={mes} style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "8px" }}>
              <span style={{ fontSize: "12px", color: C.textoMuted, width: "28px" }}>{mes}</span>
              <div style={{ flex: 1, background: C.branco, borderRadius: "4px", height: "8px" }}>
                <div style={{ background: C.verde, borderRadius: "4px", height: "8px", width: `${val * 4}%`, transition: "width 0.5s" }} />
              </div>
              <span style={{ fontSize: "12px", color: C.verde, fontWeight: "700", width: "40px" }}>{val} kg</span>
            </div>
          ))}
        </div>
        <button style={s.btn} onClick={() => { setShowImpacto(false); setShowPartilhar(true); }}>📤 Partilhar o meu impacto</button>
        <button onClick={() => setShowImpacto(false)} style={{ width: "100%", background: "none", border: "none", color: C.textoMuted, fontSize: "14px", cursor: "pointer", marginTop: "10px", fontFamily: "Georgia, serif" }}>Fechar</button>
      </Modal>

      {/* ── MODAL: Conquistas ── */}
      <Modal show={showConquistas} onClose={() => setShowConquistas(false)}>
        <ModalHeader emoji="🏆" titulo="As minhas conquistas" sub="3 desbloqueadas · 5 em progresso" onClose={() => setShowConquistas(false)} />
        <div style={{ display: "flex", flexDirection: "column", gap: "10px", marginBottom: "16px" }}>
          {conquistas.map((c, i) => (
            <div key={i} style={{ display: "flex", gap: "14px", alignItems: "center", padding: "14px", borderRadius: "14px", background: c.conquistado ? C.cremeDark : C.branco, border: `1.5px solid ${c.conquistado ? C.verde : c.pro ? C.terracota : C.cremeDark}`, opacity: c.pro ? 0.75 : 1 }}>
              <div style={{ fontSize: "28px", filter: c.conquistado ? "none" : "grayscale(60%)" }}>{c.emoji}</div>
              <div style={{ flex: 1 }}>
                <div style={{ display: "flex", alignItems: "center", gap: "6px", marginBottom: "2px" }}>
                  <span style={{ fontWeight: "700", fontSize: "13px", color: c.conquistado ? C.verde : C.texto }}>{c.titulo}</span>
                  {c.pro && <span style={{ background: C.terracota, borderRadius: "8px", padding: "1px 6px", fontSize: "9px", color: C.branco, fontWeight: "700" }}>PRO</span>}
                  {c.conquistado && <span style={{ fontSize: "12px" }}>✅</span>}
                </div>
                <div style={{ fontSize: "11px", color: C.textoMuted }}>{c.desc}</div>
                {c.conquistado && <div style={{ fontSize: "10px", color: C.verde, marginTop: "2px" }}>Conquistado em {c.data}</div>}
                {c.progresso && (
                  <div style={{ marginTop: "6px" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", fontSize: "10px", color: C.textoMuted, marginBottom: "3px" }}>
                      <span>Progresso</span><span>{c.progresso}</span>
                    </div>
                    <div style={{ background: C.cremeDark, borderRadius: "4px", height: "5px" }}>
                      <div style={{ background: C.terracota, borderRadius: "4px", height: "5px", width: `${(parseInt(c.progresso) / parseInt(c.progresso.split("/")[1])) * 100}%` }} />
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
        <button style={s.btn} onClick={() => setShowConquistas(false)}>Fechar</button>
      </Modal>

      {/* ── MODAL: Partilhar impacto PRO ── */}
      <Modal show={showPartilhar} onClose={() => setShowPartilhar(false)}>
        <ModalHeader emoji="📤" titulo="Partilhar o meu impacto" sub="Inspira outros a fazerem a diferença" onClose={() => setShowPartilhar(false)} />
        {!conquistaNotif ? (
          <>
            {/* Cartão visual simulado */}
            <div style={{ background: `linear-gradient(135deg, ${C.terracota}, ${C.verde})`, borderRadius: "20px", padding: "24px", marginBottom: "16px", textAlign: "center" }}>
              <div style={{ fontSize: "13px", color: "rgba(255,255,255,0.8)", marginBottom: "4px" }}>by Sankofa Lab</div>
              <div style={{ fontSize: "28px", fontWeight: "700", color: C.branco, fontFamily: "Georgia, serif", marginBottom: "4px" }}>
                Me<span style={{ color: C.cremeDark }}>Z</span>a
              </div>
              <div style={{ fontSize: "13px", color: "rgba(255,255,255,0.85)", marginBottom: "16px" }}>Cláudia Oliveira · Novembro 2024</div>
              <div style={{ display: "flex", justifyContent: "center", gap: "20px" }}>
                {[["🌿", "148 kg", "CO₂e evitado"], ["💧", "2.8k L", "água poupada"], ["♻️", "23 kg", "sem desperdício"]].map(([e, v, l]) => (
                  <div key={l} style={{ textAlign: "center" }}>
                    <div style={{ fontSize: "20px" }}>{e}</div>
                    <div style={{ fontSize: "16px", fontWeight: "700", color: C.branco }}>{v}</div>
                    <div style={{ fontSize: "10px", color: "rgba(255,255,255,0.75)" }}>{l}</div>
                  </div>
                ))}
              </div>
              <div style={{ marginTop: "14px", fontSize: "11px", color: "rgba(255,255,255,0.7)", fontStyle: "italic" }}>
                "O teu impacto começa com o que escolhes pôr na mesa."
              </div>
            </div>
            <div style={{ background: C.cremeDark, borderRadius: "12px", padding: "12px 16px", marginBottom: "16px" }}>
              {["Gerar cartão personalizado para partilhar", "Exportar como imagem PNG", "Partilhar diretamente no Instagram, LinkedIn ou WhatsApp", "Histórico de partilhas"].map((f, i) => (
                <div key={i} style={{ display: "flex", gap: "8px", padding: "5px 0", fontSize: "12px", color: C.texto }}>
                  <span style={{ color: C.verde }}>✓</span> {f}
                </div>
              ))}
            </div>
            <div style={{ display: "flex", gap: "8px", marginBottom: "12px" }}>
              <div style={{ background: C.terracota, borderRadius: "10px", padding: "3px 10px", fontSize: "11px", color: C.branco, fontWeight: "700" }}>PRO</div>
              <div style={{ fontSize: "11px", color: C.textoMuted, fontStyle: "italic", alignSelf: "center" }}>Disponível em breve</div>
            </div>
            <button style={s.btn} onClick={() => setConquistaNotif(true)}>🔔 Notifica-me quando estiver disponível</button>
            <button onClick={() => setShowPartilhar(false)} style={{ width: "100%", background: "none", border: "none", color: C.textoMuted, fontSize: "14px", cursor: "pointer", marginTop: "10px", fontFamily: "Georgia, serif" }}>Fechar</button>
          </>
        ) : (
          <div style={{ textAlign: "center" }}>
            <div style={{ fontSize: "52px", marginBottom: "12px" }}>🎉</div>
            <div style={{ fontSize: "18px", fontWeight: "700", color: C.verde, fontFamily: "Georgia, serif", marginBottom: "8px" }}>Ficaste na lista!</div>
            <p style={{ color: C.textoMuted, fontSize: "14px", lineHeight: 1.6, marginBottom: "24px" }}>Assim que a partilha de impacto estiver disponível, serás das primeiras a saber. Obrigada por fazeres parte da MeZa! 🌱</p>
            <button style={s.btn} onClick={() => { setShowPartilhar(false); setConquistaNotif(false); }}>Fechar</button>
          </div>
        )}
      </Modal>

      {/* ── MODAL: Conta ── */}
      <Modal show={showConta} onClose={() => setShowConta(false)}>
        <ModalHeader emoji="🔑" titulo="Alterar email / palavra-passe" onClose={() => setShowConta(false)} />
        {[{ label: "Email atual", placeholder: "xxxxxx_S@gmail.com" }, { label: "Novo email", placeholder: "novo@email.com" }, { label: "Palavra-passe atual", placeholder: "••••••••", type: "password" }, { label: "Nova palavra-passe", placeholder: "••••••••", type: "password" }].map(f => (
          <div key={f.label} style={{ marginBottom: "16px" }}>
            <label style={s.label}>{f.label}</label>
            <input style={s.input} type={f.type || "text"} placeholder={f.placeholder} />
          </div>
        ))}
        <button style={s.btn} onClick={() => setShowConta(false)}>Guardar alterações</button>
      </Modal>

      {/* ── MODAL: Privacidade ── */}
      <Modal show={showPrivacidade} onClose={() => setShowPrivacidade(false)}>
        <ModalHeader emoji="🛡️" titulo="Privacidade e dados" sub="RGPD · Os teus dados são teus" onClose={() => setShowPrivacidade(false)} />
        <p style={{ color: C.textoMuted, fontSize: "13px", lineHeight: 1.6, marginBottom: "16px" }}>A MeZa respeita o Regulamento Geral sobre a Proteção de Dados (RGPD). Os teus dados são utilizados apenas para melhorar a tua experiência e nunca são partilhados com terceiros sem consentimento.</p>
        {[{ label: "Ver os meus dados", desc: "Descarregar uma cópia de todos os teus dados", icon: "📥" }, { label: "Exportar dados em CSV", desc: "Compras, pegada, relatórios", icon: "📊" }, { label: "Apagar os meus dados", desc: "Eliminar permanentemente toda a informação", icon: "🗑️", danger: true }].map((item, i) => (
          <button key={i} style={{ width: "100%", background: item.danger ? "#FFF5F5" : C.cremeDark, border: `1px solid ${item.danger ? "#FEB2B2" : C.cremeDark}`, borderRadius: "12px", padding: "14px 16px", marginBottom: "10px", display: "flex", gap: "12px", alignItems: "center", cursor: "pointer", textAlign: "left" }}>
            <span style={{ fontSize: "20px" }}>{item.icon}</span>
            <div>
              <div style={{ fontWeight: "700", fontSize: "13px", color: item.danger ? "#C53030" : C.texto }}>{item.label}</div>
              <div style={{ fontSize: "11px", color: C.textoMuted }}>{item.desc}</div>
            </div>
          </button>
        ))}
        <button onClick={() => setShowPrivacidade(false)} style={{ width: "100%", background: "none", border: "none", color: C.textoMuted, fontSize: "14px", cursor: "pointer", marginTop: "8px", fontFamily: "Georgia, serif" }}>Fechar</button>
      </Modal>

    </div>
  );
};

// ─── ECRÃ 22: CURIOSIDADES ────────────────────────────────────────────────────
const CuriosidadesScreen = ({ onNavigate }) => {
  const [catAtiva, setCatAtiva] = useState("tudo");
  const categorias = ["tudo", "alimentação", "clima", "desperdício", "dicas"];
  const items = [
    { cat: "alimentação", emoji: "🥩", titulo: "Carne de vaca vs. vegetais", texto: "Produzir 1 kg de carne de vaca emite cerca de 27 kg de CO₂e — o equivalente a conduzir 100 km de carro.", cor: C.terracota },
    { cat: "desperdício", emoji: "🗑️", titulo: "Desperdício alimentar mundial", texto: "1/3 de toda a comida produzida no mundo é desperdiçada. Em Portugal, cada família desperdiça em média 132 kg de comida por ano.", cor: C.verde },
    { cat: "clima", emoji: "🌊", titulo: "Água invisível nos alimentos", texto: "Para produzir 1 kg de café são necessários 18.900 litros de água. Escolher produtos locais pode reduzir este impacto em até 60%.", cor: C.terracotaDark },
    { cat: "dicas", emoji: "💡", titulo: "Dica da semana", texto: "Planeia as tuas refeições com antecedência. Comprar apenas o necessário pode reduzir o desperdício alimentar em 25%.", cor: C.verde },
    { cat: "alimentação", emoji: "🐟", titulo: "Peixe sustentável", texto: "Escolher peixe certificado MSC ou de aquacultura responsável pode reduzir a tua pegada de carbono alimentar em até 40%.", cor: C.terracota },
    { cat: "dicas", emoji: "🛍️", titulo: "Saco reutilizável", texto: "Um saco de plástico demora 400 anos a decompor-se. Um saco de algodão reutilizável precisa de ser usado 131 vezes para compensar o seu fabrico.", cor: C.terracotaDark },
    { cat: "clima", emoji: "🌡️", titulo: "Frigorífico eficiente", texto: "O frigorífico é responsável por até 14% do consumo de eletricidade de um restaurante. Mantê-lo entre 3°C e 5°C é o ideal.", cor: C.verde },
  ];
  const filtrados = catAtiva === "tudo" ? items : items.filter(i => i.cat === catAtiva);

  return (
    <div style={s.screen}>
      <div style={s.topBar}>
        <MezaWordmark onClick={() => onNavigate("menu")} />
      </div>
      <div style={{ padding: "0 28px" }}>
        <span style={s.sectionTitle}>Sabia que...? 🌱</span>
        <p style={{ color: C.textoMuted, fontSize: "13px", marginBottom: "16px" }}>Curiosidades, dados e dicas sobre sustentabilidade alimentar.</p>
        {/* Filtros */}
        <div style={{ display: "flex", gap: "8px", overflowX: "auto", paddingBottom: "12px", marginBottom: "16px" }}>
          {categorias.map((cat) => (
            <button key={cat} onClick={() => setCatAtiva(cat)}
              style={{ padding: "6px 16px", borderRadius: "20px", border: "none", background: catAtiva === cat ? C.terracota : C.cremeDark, color: catAtiva === cat ? C.branco : C.texto, fontSize: "12px", cursor: "pointer", whiteSpace: "nowrap", fontFamily: "Georgia, serif" }}>
              {cat.charAt(0).toUpperCase() + cat.slice(1)}
            </button>
          ))}
        </div>
        {filtrados.map((item, i) => (
          <div key={i} style={{ ...s.card, borderLeft: `4px solid ${item.cor}` }}>
            <div style={{ fontSize: "28px", marginBottom: "8px" }}>{item.emoji}</div>
            <div style={{ fontWeight: "700", color: item.cor, marginBottom: "6px", fontSize: "15px" }}>{item.titulo}</div>
            <p style={{ color: C.textoMuted, fontSize: "13px", lineHeight: 1.6, margin: 0 }}>{item.texto}</p>
          </div>
        ))}
      </div>
      <BottomNav active="curiosidades" onNavigate={onNavigate} />
    </div>
  );
};

// ─── BARRA DE NAVEGAÇÃO GLOBAL ───────────────────────────────────────────────
const NavBar = ({ screen, navigate }) => {
  const navItems = [
    { id: "splash",       icon: "🏠", label: "Início" },
    { id: "menu",         icon: "☰",  label: "Menu" },
    { id: "sugestoes",    icon: "♡",  label: "Sugestões" },
    { id: "curiosidades", icon: "📖", label: "Saber mais" },
    { id: "notificacoes", icon: "🔔", label: "Alertas" },
    { id: "perfil",       icon: "👤", label: "Perfil" },
  ];

  // ecrãs que pertencem a cada separador
  const navMap = {
    splash: ["splash"],
    menu: ["menu","menuIndividual","adicionarCompra1","adicionarCompra2","ultimaCompra","relatorios","receitas","pegadaCarbono1","pegadaCarbono2","infoGeral","energiaUso","alimentacao","transportes","residuos","pegadaTotal","melhorias","pegadaIndividual"],
    sugestoes: ["sugestoes","sugestoesGuardadas"],
    curiosidades: ["curiosidades"],
    notificacoes: ["notificacoes"],
    perfil: ["perfil"],
  };

  const activeTab = Object.keys(navMap).find(k => navMap[k].includes(screen)) || "menu";

  return (
    <div style={{ ...s.bottomNav, position: "fixed", bottom: 0, width: "390px", zIndex: 100 }}>
      {navItems.map((item) => {
        const isActive = activeTab === item.id;
        return (
          <button key={item.id} onClick={() => navigate(item.id)}
            style={{ background: "none", border: "none", cursor: "pointer", display: "flex", flexDirection: "column", alignItems: "center", gap: "2px", padding: "4px" }}>
            {isActive ? (
              <div style={{ background: C.creme, borderRadius: "50%", width: "40px", height: "40px", display: "flex", alignItems: "center", justifyContent: "center", color: C.terracota, fontSize: "16px" }}>
                {item.icon}
              </div>
            ) : (
              <span style={{ color: "rgba(255,255,255,0.75)", fontSize: "20px", lineHeight: "40px" }}>{item.icon}</span>
            )}
          </button>
        );
      })}
    </div>
  );
};

// ─── APP PRINCIPAL ────────────────────────────────────────────────────────────
export default function MeZaApp() {
  const [screen, setScreen] = useState("splash");
  const [tomPele, setTomPele] = useState("default");
  const [demo, setDemo] = useState(null); // null | "empresa" | "individual"

  const tons = {
    default: { mao: "👋",   label: "Padrão" },
    t1:      { mao: "👋🏻", label: "Tom 1" },
    t2:      { mao: "👋🏼", label: "Tom 2" },
    t3:      { mao: "👋🏽", label: "Tom 3" },
    t4:      { mao: "👋🏾", label: "Tom 4" },
    t5:      { mao: "👋🏿", label: "Tom 5" },
  };
  const maoAtiva = tons[tomPele]?.mao || "👋";

  const navigate = (s) => setScreen(s);

  // ecrãs onde a barra de navegação aparece (não no onboarding/auth)
  const showNav = !["tipoConta","login","criarContaEmpresa","criarContaIndividual","esqueceuPassword","onboardingEmpresa","onboardingIndividual"].includes(screen);

  const screens = {
    splash: <SplashScreen onNavigate={navigate} onStartDemo={(tipo) => setDemo(tipo)} />,
    tipoConta: <TipoContaScreen onNavigate={navigate} />,
    login: <LoginScreen onNavigate={navigate} />,
    criarContaEmpresa: <CriarContaEmpresaScreen onNavigate={navigate} />,
    criarContaIndividual: <CriarContaIndividualScreen onNavigate={navigate} />,
    esqueceuPassword: <EsqueceuPasswordScreen onNavigate={navigate} />,
    onboardingEmpresa: <OnboardingEmpresaScreen onNavigate={navigate} />,
    onboardingIndividual: <OnboardingIndividualScreen onNavigate={navigate} />,
    menuIndividual: <MenuIndividualScreen onNavigate={navigate} mao={maoAtiva} />,
    pegadaIndividual: <PegadaIndividualScreen onNavigate={navigate} />,
    menu: <MenuScreen onNavigate={navigate} mao={maoAtiva} />,
    adicionarCompra1: <AdicionarCompra1Screen onNavigate={navigate} />,
    adicionarCompra2: <AdicionarCompra2Screen onNavigate={navigate} />,
    ultimaCompra: <UltimaCompraScreen onNavigate={navigate} />,
    sugestoes: <SugestoesScreen onNavigate={navigate} />,
    sugestoesGuardadas: <SugestoesGuardadasScreen onNavigate={navigate} />,
    receitas: <ReceitasScreen onNavigate={navigate} />,
    relatorios: <RelatoriosScreen onNavigate={navigate} />,
    pegadaCarbono1: <PegadaCarbono1Screen onNavigate={navigate} />,
    pegadaCarbono2: <PegadaCarbono2Screen onNavigate={navigate} />,
    infoGeral: <InfoGeralScreen onNavigate={navigate} />,
    energiaUso: <EnergiaScreen onNavigate={navigate} />,
    alimentacao: <EnergiaScreen onNavigate={navigate} />,
    transportes: <EnergiaScreen onNavigate={navigate} />,
    residuos: <EnergiaScreen onNavigate={navigate} />,
    pegadaTotal: <PegadaTotalScreen onNavigate={navigate} />,
    melhorias: <MelhoriasScreen onNavigate={navigate} />,
    notificacoes: <NotificacoesScreen onNavigate={navigate} />,
    perfil: <PerfilScreen onNavigate={navigate} tomPele={tomPele} setTomPele={setTomPele} />,
    curiosidades: <CuriosidadesScreen onNavigate={navigate} />,
  };

  return (
    <div style={s.app}>
      <div style={s.phone}>

        <div style={{ overflowY: "auto", height: "844px", position: "relative" }}>
          {screens[screen] || screens["splash"]}
        </div>
        {showNav && <NavBar screen={screen} navigate={navigate} />}
        {demo && (
          <DemoPlayer
            tipo={demo}
            onClose={() => { setDemo(null); navigate("splash"); }}
            onNavigate={navigate}
          />
        )}
      </div>
    </div>
  );
}
